export const containerKeyMap = {
  container_number: 'number',
  size: 'size',
  weight: 'weight',
  unit_mesure: 'unit_measurement',
  TEU: 'teu',
};

export const partKeyMap = {
  amount: 'quantity',
  long: 'long',
  broad: 'width',
  high: 'high',
  unit_mesure: 'unit_measurement',
  total_weight: 'weight_total',
  unit_mesure_weight: 'unit_measurement_weight',
};

export const bussiness_term = [
  { label: 'EXW' },
  { label: 'DAP' },
  { label: 'DDP' },
  { label: 'DPU' },
  { label: 'CFR' },
  { label: 'CIF' },
  { label: 'CIP' },
  { label: 'CPT' },
  { label: 'FAS' },
  { label: 'FCA' },
  { label: 'FOB' },
];

export const product_type = [
  { label: 'ABONOS VEG' },
  { label: 'ACCES VESTIR' },
  { label: 'ACCESOR COCINA GAS' },
  { label: 'ACCESORIO PLAST CONST' },
  { label: 'ACCESORIOS DE COCINA' },
  { label: 'ACCESORIOS DE INSTRUMENTOS.' },
  { label: 'ACCESORIOS DE PC' },
  { label: 'ACEITE DE COCO' },
  { label: 'aceite de vehiculos' },
  { label: 'ACEITES ALIMENTICIOS' },
  { label: 'ACRIFILM BLANCO ' },
  { label: 'ACRILICOS' },
  { label: 'ADITIVOS LUBRICAN' },
  { label: 'ADITIVOS P INSUMOS' },
  { label: 'AIRES ACONDICIONADOS' },
  { label: 'AISLADOR' },
  { label: 'ALCOH ETILICO' },
  { label: 'ALCOH ETILICO' },
  { label: 'ALFOMBRAS TEX' },
  { label: 'ALGODON ' },
  { label: 'ALGODON CARDADO' },
  { label: 'ALIMENT PARA ANIMALES' },
  { label: 'ALIMENTOS' },
  { label: 'ALMENDRAS Y NUECES' },
  { label: 'ALUMINIO' },
  { label: 'APA ELEC SEÑALI' },
  { label: 'APARAT GRABACION O REPR' },
  { label: 'APARATOS CELULARES ' },
  { label: 'APARATOS CELULARES' },
  { label: 'APARATOS ELECTRONIC' },
  { label: 'APARATOS MEC ' },
  { label: 'APARATOS TELESCOPI' },
  { label: 'ART FIESTA' },
  { label: 'ARTICULOS AGRICOLAS ' },
  { label: 'AUTOMOVIL ' },
  { label: 'AZUFRE PETROQUIMICO' },
  { label: 'BALDOSAS ' },
  { label: 'BANDAJE PAR EL REENCAUC' },
  { label: 'BARRAS DE HIERRO O DE ACERO' },
  { label: 'BATERIAS ' },
  { label: 'BEBIDAS ALCOH VINO' },
  { label: 'BICICLETAS ' },
  { label: 'BOBINAS' },
  { label: 'BOLSAS DE PLASTICO PARA EMPACA' },
  { label: 'BOMBAS DE AIRE Y REP' },
  { label: 'CABLE DE FIBRA OPTICA' },
  { label: 'CABLES' },
  { label: 'CADENAS' },
  { label: 'CAFE TE YER ' },
  { label: 'CAFE TE YERB' },
  { label: 'CAJAS ' },
  { label: 'CALENDARIOS IMPRESOS ' },
  { label: 'CALENTADOR A GAS' },
  { label: 'CALZADO' },
  { label: 'CARBONAT D BARIO ESPE' },
  { label: 'CARPAS INFLABLES CON SUS ACCES' },
  { label: 'CARTON CORRUGADO ' },
  { label: 'CASCOS ' },
  { label: 'CAUCHO ' },
  { label: 'CELULAS DE CARGA' },
  { label: 'CEMENTO' },
  { label: 'CERRADURAS ' },
  { label: 'CERVEZA DE M' },
  { label: 'CHAPAS UNIVERSAL' },
  { label: 'CIGARROS O PUROS (INCLUSO DESP' },
  { label: 'CINTAS ' },
  { label: 'COLCHONES ' },
  { label: 'COLONIAS' },
  { label: 'COMPON PA COCINAS' },
  { label: 'COMPONENTES PARA TV' },
  { label: 'COMPRESAS Y TAMPONES HIGIÉNICO' },
  { label: 'COMPRESORS Y ACCES' },
  { label: 'CONDE ELECT' },
  { label: 'CONGELADORES ' },
  { label: 'CONJUNTO CAÑON' },
  { label: 'CONSTRUCCIONES PREFABRI' },
  { label: 'CONTENEDOR ' },
  { label: 'CONTENEDOR VACIO' },
  { label: 'COPOLIMERO ABS RESIN ' },
  { label: 'COPOLIMERO ABS RESIN' },
  { label: 'CUBRELE FUNDAS ALMO' },
  { label: 'DEMAS HIERR' },
  { label: 'DEMAS HIERR' },
  { label: 'DEMAS TEJIDOS ALGODON ' },
  { label: 'DEMAS TEJIDOS P' },
  { label: 'DIFUSORES DE AROMA ' },
  { label: 'DUCHAS' },
  { label: 'DULCES Y CONFITERIA ' },
  { label: 'ELECT SEÑAL' },
  { label: 'ELECTRIC SEÑA' },
  { label: 'ENCENDI O ARRANQ' },
  { label: 'ENVASE ' },
  { label: 'EQUIPOS DE LABORAT ' },
  { label: 'EQUIPOS MEDICOS' },
  { label: 'EQUIPOS PARA EJERCICIO ' },
  { label: 'ESTIBAS' },
  { label: 'ETIQUETAS' },
  { label: 'FERROMANGANESO' },
  { label: 'FERTILIZANTES' },
  { label: 'FIBRA DE VIDRIO' },
  { label: 'FILTRO SECADOR' },
  { label: 'FOSFATO DICÁLCICO' },
  { label: 'FRUTAS Y HORTALIZAS ' },
  { label: 'GUANTE D EXAMEN D VINI' },
  { label: 'GUANTES MITO Y MAN' },
  { label: 'HERRAJ P FABRID M' },
  { label: 'HERRAMI ELECTRICAS' },
  { label: 'HERRAMIENTA INCLUIDAS LAS DE C' },
  { label: 'HILADOS' },
  { label: 'HILO DE GOMA' },
  { label: 'HOJA ALUMINIO ' },
  { label: 'HOJAS DE ALUMINIO ' },
  { label: 'INSERT O PLACA PARA MOL' },
  { label: 'JABON ' },
  { label: 'JUEG C MECANI' },
  { label: 'JUEGOS RUEDAS TRICIC ' },
  { label: 'JUGUETES ' },
  { label: 'JUGUETES' },
  { label: 'LADRILLO ' },
  { label: 'LAMINA DE ACERO INOX' },
  { label: 'LAMINA HIERR' },
  { label: 'LAMINA PVC RIGIDO ' },
  { label: 'LAMINADO ACERO' },
  { label: 'LAMINADO HIERRO' },
  { label: 'LAMINADOS HIERRO' },
  { label: 'LAMINADOS HIERRO' },
  { label: 'LAMINAS DE ALUMINIO ' },
  { label: 'LAMINAS DE CERAMICA ' },
  { label: 'LECHE SABORIZADA ' },
  { label: 'LENTES OFTAL' },
  { label: 'LIBROS ' },
  { label: 'LICORES' },
  { label: 'LLANTAS' },
  { label: 'LUMINARIAS ' },
  { label: 'MADERA Y AGLOMERA' },
  { label: 'MALETAS BOL MOCHILAS ' },
  { label: 'MALLAS DE USO AGRICOLA' },
  { label: 'MANGUERAS ' },
  { label: 'MANTOS IMPERMEABILIZANT' },
  { label: 'MANUFC VIDRIO ' },
  { label: 'MAQUINARIA Y ELECTRICOS' },
  { label: 'MAQUINAS ' },
  { label: 'MARMOL' },
  { label: 'MARTILLO HIDRA PA MAQUI' },
  { label: 'MASCARA ' },
  { label: 'MATERI AERONAUTICO' },
  { label: 'MATERIA PRIMA ' },
  { label: 'MATERIAL ELECTRICO' },
  { label: 'MEDICAMENTOS CON EX' },
  { label: 'MEDICAMENTOS' },
  { label: 'MICROFONO Y ALTAV' },
  { label: 'MOBILIAR MEDICO Y ODONT' },
  { label: 'MOBILIARIO OFICINA' },
  { label: 'MONTACARGA' },
  { label: 'MOTOR P CAMPANA EXTRA' },
  { label: 'MUEBLES ' },
  { label: 'NAVEGACION AEREA' },
  { label: 'NEUMATICOS ' },
  { label: 'PANEL SOLAR' },
  { label: 'PANELES PARA TV' },
  { label: 'PANELES PLACAS LOSETAS ' },
  { label: 'PART Y ACCES DE VEHI' },
  { label: 'PASTA DE AJI AMARILLO ' },
  { label: 'PEGAMENTO BASE DE AGUA ' },
  { label: 'PELICULAS FOTOGRAFICAS' },
  { label: 'PERFIL ALUMINIO ' },
  { label: 'PERFILES SILICONADOS' },
  { label: 'PIGMENTOS Y PINTURAS' },
  { label: 'PILAS Y BATERIAS ' },
  { label: 'PISO D MAD MULTIES' },
  { label: 'PLACAS Y BALD CERAMIC' },
  { label: 'PLACAS Y BALDOSAS' },
  { label: 'PLASTICO SILICONADO ' },
  { label: 'POLIPROPILENO Y PVC' },
  { label: 'POLVOS ' },
  { label: 'POLYEST MICROFI SOL FLA' },
  { label: 'POLYESTIRENO EXPAND ' },
  { label: 'PRENDAS DE VESTIR' },
  { label: 'PRENDAS PARA VESTIR ' },
  { label: 'PREPA ALIMEN NO' },
  { label: 'PREPARACIONES ALIMENT NO' },
  { label: 'PROD QUIM ORGANI' },
  { label: 'PRODUC CUIDADO PERSON' },
  { label: 'PRODUC DE MISCELAN' },
  { label: 'PRODUCTOS DE CERAMICA DOMESTIC' },
  { label: 'PRODUCTOS DENTALES ' },
  { label: 'PRODUCTOS FARMAC' },
  { label: 'PROYECTOR LED' },
  { label: 'PUERTAS' },
  { label: 'PUNTAS CLAVOS GRAPAS' },
  { label: 'RACOR COD MANG' },
  { label: 'RECEPTOR DE TV' },
  { label: 'RECIPIENTES DE PLASTICO' },
  { label: 'REDES DE MALLAS' },
  { label: 'refrigerador ' },
  { label: 'REJI HIER FUNDI' },
  { label: 'REPUES AUTOMOTORES ' },
  { label: 'REPUESTOS ' },
  { label: 'RESINA' },
  { label: 'RESISTENCIAS ' },
  { label: 'ROLLOS DE PAPEL ' },
  { label: 'SANGRE ' },
  { label: 'SILICATO DE ALUMINIO ' },
  { label: 'SILLAS Y ACCESORIOS ' },
  { label: 'SOLD REMACH GRAP' },
  { label: 'TAPONES Y TAPAS' },
  { label: 'TEJIDO DE PUNTO ' },
  { label: 'TEJIDO E HILADOS' },
  { label: 'TEJIDOS DE ALGODON ' },
  { label: 'TEXTIL ALCOCHADOS' },
  { label: 'TEXTILES ' },
  { label: 'TIERRA' },
  { label: 'TINTAS DE IMPRESION ' },
  { label: 'TOALLAS ALGODON ' },
  { label: 'TORNILL PERNOS TUERCAS' },
  { label: 'TRACTORES' },
  { label: 'TRAILER' },
  { label: 'TRANSFROMADORES ' },
  { label: 'TUB ALUMIN' },
  { label: 'TUBOS' },
  { label: 'UPS Y BATERIAS ' },
  { label: 'VALVULAS ' },
  { label: 'VIDRIO ' },
  { label: 'VIDRIO SEG ' },
  { label: 'ZINC EN LINGOTES' },
];

export const cities = [
  { label: 'AMAZONAS-EL ENCANTO' },
  { label: 'AMAZONAS-LA CHRERA' },
  { label: 'AMAZONAS-LA PEDRERA' },
  { label: 'AMAZONAS-LA VICTIA' },
  { label: 'AMAZONAS-LETICIA' },
  { label: 'AMAZONAS-MIRITI PARANA' },
  { label: 'AMAZONAS-PUERTO' },
  { label: 'AMAZONAS-PUERTO' },
  { label: 'AMAZONAS-PUERTO ALEGRIA' },
  { label: 'AMAZONAS-PUERTO ARICA' },
  { label: 'AMAZONAS-TARAPACA' },
  { label: 'ANTIOQUIA-ABEJRAL' },
  { label: 'ANTIOQUIA-ABRIAQUI' },
  { label: 'ANTIOQUIA-ALEJANDRIA' },
  { label: 'ANTIOQUIA-AMAGA' },
  { label: 'ANTIOQUIA-AMALFI' },
  { label: 'ANTIOQUIA-ANDES' },
  { label: 'ANTIOQUIA-ANGELOPOLIS' },
  { label: 'ANTIOQUIA-ANGOSTURA' },
  { label: 'ANTIOQUIA-ANI' },
  { label: 'ANTIOQUIA-ANZA' },
  { label: 'ANTIOQUIA-APARTADO' },
  { label: 'ANTIOQUIA-ARBOLETES' },
  { label: 'ANTIOQUIA-ARGELIA' },
  { label: 'ANTIOQUIA-ARMENIA' },
  { label: 'ANTIOQUIA-BARBOSA' },
  { label: 'ANTIOQUIA-BELLO' },
  { label: 'ANTIOQUIA-BELMIRA' },
  { label: 'ANTIOQUIA-BETANIA' },
  { label: 'ANTIOQUIA-BETULIA' },
  { label: 'ANTIOQUIA-BRICENO' },
  { label: 'ANTIOQUIA-BURITICA' },
  { label: 'ANTIOQUIA-CACERES' },
  { label: 'ANTIOQUIA-CAICEDO' },
  { label: 'ANTIOQUIA-CALDAS' },
  { label: 'ANTIOQUIA-CAMPAMENTO' },
  { label: 'ANTIOQUIA-CANASGDAS' },
  { label: 'ANTIOQUIA-CARACOLI' },
  { label: 'ANTIOQUIA-CARAMANTA' },
  { label: 'ANTIOQUIA-CAREPA' },
  { label: 'ANTIOQUIA-CAROLINA' },
  { label: 'ANTIOQUIA-CAUCASIA' },
  { label: 'ANTIOQUIA-CHIGODO' },
  { label: 'ANTIOQUIA-CISNEROS' },
  { label: 'ANTIOQUIA-CIUDAD BOLIVAR' },
  { label: 'ANTIOQUIA-COCNA' },
  { label: 'ANTIOQUIA-CONCDIA' },
  { label: 'ANTIOQUIA-CONCEPCION' },
  { label: 'ANTIOQUIA-COPACABANA' },
  { label: 'ANTIOQUIA-DABEIBA' },
  { label: 'ANTIOQUIA-DON MATIAS' },
  { label: 'ANTIOQUIA-EBEJICO' },
  { label: 'ANTIOQUIA-EL BAGRE' },
  { label: 'ANTIOQUIA-EL CARMEN DE VIBAL' },
  { label: 'ANTIOQUIA-EL SANTUARIO' },
  { label: 'ANTIOQUIA-ENTRERRIOS' },
  { label: 'ANTIOQUIA-ENVIGADO' },
  { label: 'ANTIOQUIA-FREDONIA' },
  { label: 'ANTIOQUIA-FRONTINO' },
  { label: 'ANTIOQUIA-GIRALDO' },
  { label: 'ANTIOQUIA-GIRARDOTA' },
  { label: 'ANTIOQUIA-GOMEZ PLATA' },
  { label: 'ANTIOQUIA-GRANADA' },
  { label: 'ANTIOQUIA-GUADALUPE' },
  { label: 'ANTIOQUIA-GUARNE' },
  { label: 'ANTIOQUIA-GUATAPE' },
  { label: 'ANTIOQUIA-HELICONIA' },
  { label: 'ANTIOQUIA-HISPANIA' },
  { label: 'ANTIOQUIA-ITAGUI' },
  { label: 'ANTIOQUIA-ITUANGO' },
  { label: 'ANTIOQUIA-JARDIN' },
  { label: 'ANTIOQUIA-JERICO' },
  { label: 'ANTIOQUIA-LA CEJA' },
  { label: 'ANTIOQUIA-LA ESTRELLA' },
  { label: 'ANTIOQUIA-LA PINTADA' },
  { label: 'ANTIOQUIA-LA UNION' },
  { label: 'ANTIOQUIA-LIBINA' },
  { label: 'ANTIOQUIA-MACEO' },
  { label: 'ANTIOQUIA-MARINILLA' },
  { label: 'ANTIOQUIA-MEDELLIN' },
  { label: 'ANTIOQUIA-MONTEBELLO' },
  { label: 'ANTIOQUIA-MURINDO' },
  { label: 'ANTIOQUIA-MUTATA' },
  { label: 'ANTIOQUIA-NARINO' },
  { label: 'ANTIOQUIA-NECHI' },
  { label: 'ANTIOQUIA-NECOCLI' },
  { label: 'ANTIOQUIA-OLAYA' },
  { label: 'ANTIOQUIA-PENOL' },
  { label: 'ANTIOQUIA-PEQUE' },
  { label: 'ANTIOQUIA-PUEBLRICO' },
  { label: 'ANTIOQUIA-PUERTO BERRIO' },
  { label: 'ANTIOQUIA-PUERTO NARE' },
  { label: 'ANTIOQUIA-PUERTO TRIUNFO' },
  { label: 'ANTIOQUIA-REMEDIOS' },
  { label: 'ANTIOQUIA-RETIRO' },
  { label: 'ANTIOQUIA-RIONEGRO' },
  { label: 'ANTIOQUIA-SABANALARGA' },
  { label: 'ANTIOQUIA-SABANETA' },
  { label: 'ANTIOQUIA-SALGAR' },
  { label: 'ANTIOQUIA-SAN ANDRES' },
  { label: 'ANTIOQUIA-SAN CARLOS' },
  { label: 'ANTIOQUIA-SAN FRANCISCO' },
  { label: 'ANTIOQUIA-SAN JERONIMO' },
  { label: 'ANTIOQUIA-SAN JOSE DE LA MONTANA' },
  { label: 'ANTIOQUIA-SAN JUAN DE URABA' },
  { label: 'ANTIOQUIA-SAN LUIS' },
  { label: 'ANTIOQUIA-SAN PEDRO' },
  { label: 'ANTIOQUIA-SAN PEDRO URABA' },
  { label: 'ANTIOQUIA-SAN RAFAEL' },
  { label: 'ANTIOQUIA-SAN ROQUE' },
  { label: 'ANTIOQUIA-SAN VICENTE' },
  { label: 'ANTIOQUIA-SANTA BARBARA' },
  { label: 'ANTIOQUIA-SANTA ROSA DE OSOS' },
  { label: 'ANTIOQUIA-SANTAFE DE ANTIOQUIA -' },
  { label: 'ANTIOQUIA-SANTO DOMINGO' },
  { label: 'ANTIOQUIA-SEGOVIA' },
  { label: 'ANTIOQUIA-SONSON' },
  { label: 'ANTIOQUIA-SOPETRAN' },
  { label: 'ANTIOQUIA-TAMESIS' },
  { label: 'ANTIOQUIA-TARAZA' },
  { label: 'ANTIOQUIA-TARSO' },
  { label: 'ANTIOQUIA-TITIRIBI' },
  { label: 'ANTIOQUIA-TOLEDO' },
  { label: 'ANTIOQUIA-TURBO' },
  { label: 'ANTIOQUIA-URAMITA' },
  { label: 'ANTIOQUIA-URRAO' },
  { label: 'ANTIOQUIA-VALDIVIA' },
  { label: 'ANTIOQUIA-VALPARAISO' },
  { label: 'ANTIOQUIA-VEGACHI' },
  { label: 'ANTIOQUIA-VENECIA' },
  { label: 'ANTIOQUIA-VIGIA DEL FUERTE' },
  { label: 'ANTIOQUIA-YALI' },
  { label: 'ANTIOQUIA-YARUMAL' },
  { label: 'ANTIOQUIA-YOLOMBO' },
  { label: 'ANTIOQUIA-YONDO' },
  { label: 'ANTIOQUIA-ZARAGOZA' },
  { label: 'ARAUCA-ARAUCA' },
  { label: 'ARAUCA-ARAUQUITA' },
  { label: 'ARAUCA-CRAVO NTE' },
  { label: 'ARAUCA-FTUL' },
  { label: 'ARAUCA-PUERTO RONDON' },
  { label: 'ARAUCA-SARAVENA' },
  { label: 'ARAUCA-TAME' },
  { label: 'ATLANTICO-BARANOA' },
  { label: 'ATLANTICO-BARRANQUILLA' },
  { label: 'ATLANTICO-CAMPO DE LA CRUZ' },
  { label: 'ATLANTICO-CANDELARIA' },
  { label: 'ATLANTICO-GALAPA' },
  { label: 'ATLANTICO-JUAN DE ACOSTA' },
  { label: 'ATLANTICO-LURUACO' },
  { label: 'ATLANTICO-MALAMBO' },
  { label: 'ATLANTICO-MANATI' },
  { label: 'ATLANTICO-PALMAR DE VARELA' },
  { label: 'ATLANTICO-PIOJO' },
  { label: 'ATLANTICO-POLONUEVO' },
  { label: 'ATLANTICO-PONEDERA' },
  { label: 'ATLANTICO-PUERTO COLOMBIA' },
  { label: 'ATLANTICO-REPELON' },
  { label: 'ATLANTICO-SABANAGRANDE' },
  { label: 'ATLANTICO-SABANALARGA' },
  { label: 'ATLANTICO-SANTA LUCIA' },
  { label: 'ATLANTICO-SANTO TOMAS' },
  { label: 'ATLANTICO-SOLEDAD' },
  { label: 'ATLANTICO-SUAN' },
  { label: 'ATLANTICO-TUBARA' },
  { label: 'ATLANTICO-USIACURI' },
  { label: 'BOGOTA DC-BOGOTA DC' },
  { label: 'BOLIVAR-ACHI' },
  { label: 'BOLIVAR-ALTOS DEL ROSARIO' },
  { label: 'BOLIVAR-ARENAL' },
  { label: 'BOLIVAR-ARJONA' },
  { label: 'BOLIVAR-ARROYOHONDO' },
  { label: 'BOLIVAR-BARRANCO DE LOBA' },
  { label: 'BOLIVAR-CALAMAR' },
  { label: 'BOLIVAR-CANTAGALLO' },
  { label: 'BOLIVAR-CARTAGENA DE INDIAS' },
  { label: 'BOLIVAR-CDOBA' },
  { label: 'BOLIVAR-CICUCO' },
  { label: 'BOLIVAR-CLEMENCIA' },
  { label: 'BOLIVAR-EL CARMEN DE BOLIVAR' },
  { label: 'BOLIVAR-EL GUAMO' },
  { label: 'BOLIVAR-EL PENON' },
  { label: 'BOLIVAR-HATILLO DE LOBA' },
  { label: 'BOLIVAR-MAGANGUE' },
  { label: 'BOLIVAR-MAHATES' },
  { label: 'BOLIVAR-MALES' },
  { label: 'BOLIVAR-MARGARITA' },
  { label: 'BOLIVAR-MARIA LA BAJA' },
  { label: 'BOLIVAR-MOMPOS' },
  { label: 'BOLIVAR-MONTECRISTO' },
  { label: 'BOLIVAR-PINILLOS' },
  { label: 'BOLIVAR-REGID' },
  { label: 'BOLIVAR-RIO VIEJO' },
  { label: 'BOLIVAR-SAN CRISTOBAL' },
  { label: 'BOLIVAR-SAN ESTNALISLAO' },
  { label: 'BOLIVAR-SAN FERNANDO' },
  { label: 'BOLIVAR-SAN JACINTO' },
  { label: 'BOLIVAR-SAN JACINTO DEL CAUCA' },
  { label: 'BOLIVAR-SAN JUAN NEPOMUCENO' },
  { label: 'BOLIVAR-SAN MARTIN DE LOBA' },
  { label: 'BOLIVAR-SAN PABLO' },
  { label: 'BOLIVAR-SANTA CATALINA' },
  { label: 'BOLIVAR-SANTA ROSA' },
  { label: 'BOLIVAR-SANTA ROSA DEL SUR' },
  { label: 'BOLIVAR-SIMITI' },
  { label: 'BOLIVAR-SOPLAVIENTO' },
  { label: 'BOLIVAR-TALAIGUA NUEVO' },
  { label: 'BOLIVAR-TIQUISIO' },
  { label: 'BOLIVAR-TURBACO' },
  { label: 'BOLIVAR-TURBANA' },
  { label: 'BOLIVAR-VILLANUEVA' },
  { label: 'BOLIVAR-ZAMBRANO' },
  { label: 'BOYACA-ALMEIDA' },
  { label: 'BOYACA-AQUITANIA' },
  { label: 'BOYACA-ARCABUCO' },
  { label: 'BOYACA-BELEN' },
  { label: 'BOYACA-BERBEO' },
  { label: 'BOYACA-BETEITIVA' },
  { label: 'BOYACA-BOAVITA' },
  { label: 'BOYACA-BOYACA' },
  { label: 'BOYACA-BRICENO' },
  { label: 'BOYACA-BUENAVISTA' },
  { label: 'BOYACA-BUSBANZA' },
  { label: 'BOYACA-CALDAS' },
  { label: 'BOYACA-CAMPOHERMOSO' },
  { label: 'BOYACA-CERINZA' },
  { label: 'BOYACA-CHINAVITA' },
  { label: 'BOYACA-CHIQUINQUIRA' },
  { label: 'BOYACA-CHIQUIZA' },
  { label: 'BOYACA-CHISCAS' },
  { label: 'BOYACA-CHITA' },
  { label: 'BOYACA-CHITARAQUE' },
  { label: 'BOYACA-CHIV' },
  { label: 'BOYACA-CHIVATA' },
  { label: 'BOYACA-CIENEGA' },
  { label: 'BOYACA-COMBITA' },
  { label: 'BOYACA-COPER' },
  { label: 'BOYACA-COVARACHIA' },
  { label: 'BOYACA-CRALES' },
  { label: 'BOYACA-CUBARA' },
  { label: 'BOYACA-CUCAITA' },
  { label: 'BOYACA-CUITIVA' },
  { label: 'BOYACA-DUITAMA' },
  { label: 'BOYACA-EL COCUY' },
  { label: 'BOYACA-EL ESPINO' },
  { label: 'BOYACA-FIRAVITOBA' },
  { label: 'BOYACA-FLESTA' },
  { label: 'BOYACA-GACHANTIVA' },
  { label: 'BOYACA-GAMEZA' },
  { label: 'BOYACA-GARAGOA' },
  { label: 'BOYACA-GUACAMAYAS' },
  { label: 'BOYACA-GUATEQUE' },
  { label: 'BOYACA-GUAYATA' },
  { label: 'BOYACA-GUICAN' },
  { label: 'BOYACA-IZA' },
  { label: 'BOYACA-JENESANO' },
  { label: 'BOYACA-JERICO' },
  { label: 'BOYACA-LA CAPILLA' },
  { label: 'BOYACA-LA UVITA' },
  { label: 'BOYACA-LA VICTIA' },
  { label: 'BOYACA-LABRANZAGRANDE' },
  { label: 'BOYACA-MACANAL' },
  { label: 'BOYACA-MARIPI' },
  { label: 'BOYACA-MIRAFLES' },
  { label: 'BOYACA-MONGUA' },
  { label: 'BOYACA-MONGUI' },
  { label: 'BOYACA-MONIQUIRA' },
  { label: 'BOYACA-MOTAVITA' },
  { label: 'BOYACA-MUZO' },
  { label: 'BOYACA-NOBSA' },
  { label: 'BOYACA-NUEVO COLON' },
  { label: 'BOYACA-OICATA' },
  { label: 'BOYACA-OTANCHE' },
  { label: 'BOYACA-PACHAVITA' },
  { label: 'BOYACA-PAEZ' },
  { label: 'BOYACA-PAIPA' },
  { label: 'BOYACA-PAJARITO' },
  { label: 'BOYACA-PANQUEBA' },
  { label: 'BOYACA-PAUNA' },
  { label: 'BOYACA-PAYA' },
  { label: 'BOYACA-PAZ DE RIO' },
  { label: 'BOYACA-PESCA' },
  { label: 'BOYACA-PISBA' },
  { label: 'BOYACA-PUERTO' },
  { label: 'BOYACA-QUIPAMA' },
  { label: 'BOYACA-RAMIRIQUI' },
  { label: 'BOYACA-RAQUIRA' },
  { label: 'BOYACA-RONDON' },
  { label: 'BOYACA-SA' },
  { label: 'BOYACA-SABOYA' },
  { label: 'BOYACA-SACA' },
  { label: 'BOYACA-SACHICA' },
  { label: 'BOYACA-SAMACA' },
  { label: 'BOYACA-SAN EDUARDO' },
  { label: 'BOYACA-SAN JOSE DE PARE' },
  { label: 'BOYACA-SAN LUIS DE GACENO' },
  { label: 'BOYACA-SAN MATEO' },
  { label: 'BOYACA-SAN MIGUEL DE SEMA' },
  { label: 'BOYACA-SAN PABLO DE BBUR' },
  { label: 'BOYACA-SANTA MARIA' },
  { label: 'BOYACA-SANTA ROSA DE VITERBO' },
  { label: 'BOYACA-SANTA SOFIA' },
  { label: 'BOYACA-SANTANA' },
  { label: 'BOYACA-SATIVANTE' },
  { label: 'BOYACA-SATIVASUR' },
  { label: 'BOYACA-SIACHOQUE' },
  { label: 'BOYACA-SOATA' },
  { label: 'BOYACA-SOCHA' },
  { label: 'BOYACA-SOCOTA' },
  { label: 'BOYACA-SOGAMOSO' },
  { label: 'BOYACA-SOMONDOCO' },
  { label: 'BOYACA-SOTAQUIRA' },
  { label: 'BOYACA-SUSACON' },
  { label: 'BOYACA-SUTAMARCHAN' },
  { label: 'BOYACA-SUTATENZA' },
  { label: 'BOYACA-TASCO' },
  { label: 'BOYACA-TENZA' },
  { label: 'BOYACA-TIBANA' },
  { label: 'BOYACA-TIBASOSA' },
  { label: 'BOYACA-TINJACA' },
  { label: 'BOYACA-TIPACOQUE' },
  { label: 'BOYACA-TOCA' },
  { label: 'BOYACA-TOGUI' },
  { label: 'BOYACA-TOPAGA' },
  { label: 'BOYACA-TOTA' },
  { label: 'BOYACA-TUNJA' },
  { label: 'BOYACA-TUNUNGUA' },
  { label: 'BOYACA-TURMEQUA' },
  { label: 'BOYACA-TUTA' },
  { label: 'BOYACA-TUTAZA' },
  { label: 'BOYACA-UMBITA' },
  { label: 'BOYACA-VENTAQUEMADA' },
  { label: 'BOYACA-VILLA DE LEYVA' },
  { label: 'BOYACA-VIRACACHA' },
  { label: 'BOYACA-ZETAQUIRA' },
  { label: 'CALDAS-AGUADAS' },
  { label: 'CALDAS-ANSERMA' },
  { label: 'CALDAS-ARANZAZU' },
  { label: 'CALDAS-BELALCAZAR' },
  { label: 'CALDAS-CHINCHINA' },
  { label: 'CALDAS-FILADELFIA' },
  { label: 'CALDAS-LA DADA' },
  { label: 'CALDAS-LA MERCED' },
  { label: 'CALDAS-MANIZALES' },
  { label: 'CALDAS-MANZANARES' },
  { label: 'CALDAS-MARMATO' },
  { label: 'CALDAS-MARQUETALIA' },
  { label: 'CALDAS-MARULANDA' },
  { label: 'CALDAS-NCASIA' },
  { label: 'CALDAS-NEIRA' },
  { label: 'CALDAS-PACA' },
  { label: 'CALDAS-PALESTINA' },
  { label: 'CALDAS-PENSILVANIA' },
  { label: 'CALDAS-RIOSUCIO' },
  { label: 'CALDAS-RISARALDA' },
  { label: 'CALDAS-SALAMINA' },
  { label: 'CALDAS-SAMANA' },
  { label: 'CALDAS-SAN JOSE DE PARE' },
  { label: 'CALDAS-SUPIA' },
  { label: 'CALDAS-VICTIA' },
  { label: 'CALDAS-VILLAMARIA' },
  { label: 'CALDAS-VITERBO' },
  { label: 'CAQUETA-ALBANIA' },
  { label: 'CAQUETA-BELEN DE LOS ANDAQUIES' },
  { label: 'CAQUETA-CARTAGENA DEL CHAIRA' },
  { label: 'CAQUETA-CURILLO' },
  { label: 'CAQUETA-EL DONCELLO' },
  { label: 'CAQUETA-EL PAUJIL' },
  { label: 'CAQUETA-FLENCIA' },
  { label: 'CAQUETA-LA MONTANITA' },
  { label: 'CAQUETA-MELIA' },
  { label: 'CAQUETA-MILAN' },
  { label: 'CAQUETA-PUERTO RICO' },
  { label: 'CAQUETA-SAN JOSE DEL FRAGUA' },
  { label: 'CAQUETA-SAN VICENTE DEL CAGUAN' },
  { label: 'CAQUETA-SOLANO' },
  { label: 'CAQUETA-SOLITA' },
  { label: 'CAQUETA-VALPARAISO' },
  { label: 'CASANARE-AGUAZUL' },
  { label: 'CASANARE-CHAMEZA' },
  { label: 'CASANARE-HATO COZAL' },
  { label: 'CASANARE-LA SALINA' },
  { label: 'CASANARE-MANIZALES' },
  { label: 'CASANARE-MONTERREY' },
  { label: 'CASANARE-NUNCHIA' },
  { label: 'CASANARE-OCUE' },
  { label: 'CASANARE-PAZ DE ARIPO' },
  { label: 'CASANARE-PE' },
  { label: 'CASANARE-RECET' },
  { label: 'CASANARE-SABANALARGA' },
  { label: 'CASANARE-SACAMA' },
  { label: 'CASANARE-SAN LUIS DE PALENQUE' },
  { label: 'CASANARE-TAMARA' },
  { label: 'CASANARE-TAURAMENA' },
  { label: 'CASANARE-TRINIDAD' },
  { label: 'CASANARE-VILLANUEVA' },
  { label: 'CASANARE-YOPAL' },
  { label: 'CAUCA-ALMAGUER' },
  { label: 'CAUCA-ARGELIA' },
  { label: 'CAUCA-BALBOA' },
  { label: 'CAUCA-BOLIVAR' },
  { label: 'CAUCA-BUENOS AIRES' },
  { label: 'CAUCA-CAJIBIO' },
  { label: 'CAUCA-CALDONO' },
  { label: 'CAUCA-CALOTO' },
  { label: 'CAUCA-CINTO' },
  { label: 'CAUCA-EL TAMBO' },
  { label: 'CAUCA-FLENCIA' },
  { label: 'CAUCA-GUAPI' },
  { label: 'CAUCA-INZA' },
  { label: 'CAUCA-JAMBALO' },
  { label: 'CAUCA-LA SIERRA' },
  { label: 'CAUCA-LA VEGA' },
  { label: 'CAUCA-LOPEZ' },
  { label: 'CAUCA-MALES' },
  { label: 'CAUCA-MERCADERES' },
  { label: 'CAUCA-MIRANDA' },
  { label: 'CAUCA-PADILLA' },
  { label: 'CAUCA-PAEZ' },
  { label: 'CAUCA-PATIA' },
  { label: 'CAUCA-PIAMONTE' },
  { label: 'CAUCA-PIENDAMO' },
  { label: 'CAUCA-POPAYAN' },
  { label: 'CAUCA-PUERTO TEJADA' },
  { label: 'CAUCA-PURACE' },
  { label: 'CAUCA-ROSAS' },
  { label: 'CAUCA-SAN SEBASTIAN' },
  { label: 'CAUCA-SANTA ROSA' },
  { label: 'CAUCA-SANTANDER DE QUILICHAO' },
  { label: 'CAUCA-SILVIA' },
  { label: 'CAUCA-SOTARA' },
  { label: 'CAUCA-SUAREZ' },
  { label: 'CAUCA-SUCRE' },
  { label: 'CAUCA-TIBIO' },
  { label: 'CAUCA-TIMBIO' },
  { label: 'CAUCA-TIMBIQUI' },
  { label: 'CAUCA-TOTO' },
  { label: 'CAUCA-VILLA RICA' },
  { label: 'CDOBA-AYAPEL' },
  { label: 'CDOBA-BUENAVISTA' },
  { label: 'CDOBA-CANALETE' },
  { label: 'CDOBA-CERETE' },
  { label: 'CDOBA-CHIMA' },
  { label: 'CDOBA-CHINU' },
  { label: 'CDOBA-CIENAGA DE O' },
  { label: 'CDOBA-COTRA' },
  { label: 'CDOBA-LA APARTADA' },
  { label: 'CDOBA-LICA' },
  { label: 'CDOBA-LOS CDOBAS' },
  { label: 'CDOBA-MOMIL' },
  { label: 'CDOBA-MONITOS' },
  { label: 'CDOBA-MONTELIBANO' },
  { label: 'CDOBA-MONTERIA' },
  { label: 'CDOBA-PLANETA RICA' },
  { label: 'CDOBA-PUEBLO NUEVO' },
  { label: 'CDOBA-PUERTO ESCONDIDO' },
  { label: 'CDOBA-PUERTO LIBERTAD' },
  { label: 'CDOBA-PURISIMA' },
  { label: 'CDOBA-SAHAGUN' },
  { label: 'CDOBA-SAN ANDRES SOTAVENTO' },
  { label: 'CDOBA-SAN ANTERO' },
  { label: 'CDOBA-SAN BERNARDO DEL VIENTO' },
  { label: 'CDOBA-SAN CARLOS' },
  { label: 'CDOBA-SAN PELAYO' },
  { label: 'CDOBA-TIERRALTA' },
  { label: 'CDOBA-VALENCIA' },
  { label: 'CESAR-AGUACHICA' },
  { label: 'CESAR-AGUSTIN CODAZZI' },
  { label: 'CESAR-ASTREA' },
  { label: 'CESAR-BECERRIL' },
  { label: 'CESAR-BOSCONIA' },
  { label: 'CESAR-CHIMICHAGUA' },
  { label: 'CESAR-CHIRIGUANA' },
  { label: 'CESAR-CURUMANI' },
  { label: 'CESAR-EL COPEY' },
  { label: 'CESAR-EL PASO' },
  { label: 'CESAR-GAMARRA' },
  { label: 'CESAR-GONZALEZ' },
  { label: 'CESAR-LA GLIA' },
  { label: 'CESAR-LA JAGUA DE IBIRICO' },
  { label: 'CESAR-LA PAZ' },
  { label: 'CESAR-MANAURE' },
  { label: 'CESAR-PAILITAS' },
  { label: 'CESAR-PELAYA' },
  { label: 'CESAR-PUEBLO BELLO' },
  { label: 'CESAR-RIO DE O' },
  { label: 'CESAR-SAN ALBERTO' },
  { label: 'CESAR-SAN DIEGO' },
  { label: 'CESAR-SAN MARTIN' },
  { label: 'CESAR-TAMALAMEQUE' },
  { label: 'CESAR-VALLEDUPAR' },
  { label: 'CHOCO-ACANDI' },
  { label: 'CHOCO-ALTO BAUDO' },
  { label: 'CHOCO-ATRATO' },
  { label: 'CHOCO-BAGADO' },
  { label: 'CHOCO-BAHIA SOLANO' },
  { label: 'CHOCO-BAJO BAUDO' },
  { label: 'CHOCO-BELEN DE BAJIRA' },
  { label: 'CHOCO-BOJAYA' },
  { label: 'CHOCO-CARMEN DE DARIEN' },
  { label: 'CHOCO-CERTEGUI' },
  { label: 'CHOCO-CONDOTO' },
  { label: 'CHOCO-EL CANTON DEL SAN PABLO' },
  { label: 'CHOCO-EL CARMEN DE ATRATO' },
  { label: 'CHOCO-EL LITAL DEL SAN JUAN' },
  { label: 'CHOCO-ISTMINA' },
  { label: 'CHOCO-JURADO' },
  { label: 'CHOCO-LLO' },
  { label: 'CHOCO-MEDIO ATRATO' },
  { label: 'CHOCO-MEDIO BAUDO' },
  { label: 'CHOCO-MEDIO SAN JUAN' },
  { label: 'CHOCO-NOVITA' },
  { label: 'CHOCO-NUQUI' },
  { label: 'CHOCO-QUIBDO' },
  { label: 'CHOCO-RIO IRO' },
  { label: 'CHOCO-RIO QUITO' },
  { label: 'CHOCO-RIOSUCIO' },
  { label: 'CHOCO-SAN JOSE DEL PALMAR' },
  { label: 'CHOCO-SIPI' },
  { label: 'CHOCO-TADO' },
  { label: 'CHOCO-UNGUIA' },
  { label: 'CHOCO-UNION PANAMERICANA' },
  { label: 'CUNDINAMARCA-AGUA DE DIOS' },
  { label: 'CUNDINAMARCA-ALBAN' },
  { label: 'CUNDINAMARCA-ANAPOIMA' },
  { label: 'CUNDINAMARCA-ANOLAIMA' },
  { label: 'CUNDINAMARCA-APULO' },
  { label: 'CUNDINAMARCA-ARBELAEZ' },
  { label: 'CUNDINAMARCA-BELTRAN' },
  { label: 'CUNDINAMARCA-BITUIMA' },
  { label: 'CUNDINAMARCA-BOJACA' },
  { label: 'CUNDINAMARCA-CABRERA' },
  { label: 'CUNDINAMARCA-CACHIPAY' },
  { label: 'CUNDINAMARCA-CAJICA' },
  { label: 'CUNDINAMARCA-CAPARRAPI' },
  { label: 'CUNDINAMARCA-CAQUEZA' },
  { label: 'CUNDINAMARCA-CARMEN DE CARUPA' },
  { label: 'CUNDINAMARCA-CHAGUANI' },
  { label: 'CUNDINAMARCA-CHIA' },
  { label: 'CUNDINAMARCA-CHIPAQUE' },
  { label: 'CUNDINAMARCA-CHOACHI' },
  { label: 'CUNDINAMARCA-CHOCONTA' },
  { label: 'CUNDINAMARCA-COGUA' },
  { label: 'CUNDINAMARCA-COTA' },
  { label: 'CUNDINAMARCA-CUCUNUBA' },
  { label: 'CUNDINAMARCA-EL COLEGIO' },
  { label: 'CUNDINAMARCA-EL PENON' },
  { label: 'CUNDINAMARCA-EL ROSAL' },
  { label: 'CUNDINAMARCA-FACATATIVA' },
  { label: 'CUNDINAMARCA-FOMEQUE' },
  { label: 'CUNDINAMARCA-FOSCA' },
  { label: 'CUNDINAMARCA-FUNZA' },
  { label: 'CUNDINAMARCA-FUQUENE' },
  { label: 'CUNDINAMARCA-FUSAGASUGA' },
  { label: 'CUNDINAMARCA-GACHALA' },
  { label: 'CUNDINAMARCA-GACHANCIPA' },
  { label: 'CUNDINAMARCA-GACHETA' },
  { label: 'CUNDINAMARCA-GAMA' },
  { label: 'CUNDINAMARCA-GIRARDOT' },
  { label: 'CUNDINAMARCA-GRANADA' },
  { label: 'CUNDINAMARCA-GUACHETA' },
  { label: 'CUNDINAMARCA-GUADUAS' },
  { label: 'CUNDINAMARCA-GUASCA' },
  { label: 'CUNDINAMARCA-GUATAQUI' },
  { label: 'CUNDINAMARCA-GUATAVITA' },
  { label: 'CUNDINAMARCA-GUAYABAL DE SIQUIMA' },
  { label: 'CUNDINAMARCA-GUAYABETAL' },
  { label: 'CUNDINAMARCA-GUTIERREZ' },
  { label: 'CUNDINAMARCA-JERUSALEN' },
  { label: 'CUNDINAMARCA-JUNIN' },
  { label: 'CUNDINAMARCA-LA CALERA' },
  { label: 'CUNDINAMARCA-LA MESA' },
  { label: 'CUNDINAMARCA-LA PALMA' },
  { label: 'CUNDINAMARCA-LA PENA' },
  { label: 'CUNDINAMARCA-LA VEGA' },
  { label: 'CUNDINAMARCA-LENGUAZAQUE' },
  { label: 'CUNDINAMARCA-MACHETA' },
  { label: 'CUNDINAMARCA-MADRID' },
  { label: 'CUNDINAMARCA-MANTA' },
  { label: 'CUNDINAMARCA-MEDINA' },
  { label: 'CUNDINAMARCA-MOSQUERA' },
  { label: 'CUNDINAMARCA-NARINO' },
  { label: 'CUNDINAMARCA-NEMOCON' },
  { label: 'CUNDINAMARCA-NILO' },
  { label: 'CUNDINAMARCA-NIMAIMA' },
  { label: 'CUNDINAMARCA-NOCAIMA' },
  { label: 'CUNDINAMARCA-PACHO' },
  { label: 'CUNDINAMARCA-PAIME' },
  { label: 'CUNDINAMARCA-PANDI' },
  { label: 'CUNDINAMARCA-PARATEBUENO' },
  { label: 'CUNDINAMARCA-PASCA' },
  { label: 'CUNDINAMARCA-PUERTO SALGAR' },
  { label: 'CUNDINAMARCA-PULI' },
  { label: 'CUNDINAMARCA-QUEBRADANEGRA' },
  { label: 'CUNDINAMARCA-QUETAME' },
  { label: 'CUNDINAMARCA-QUIPILE' },
  { label: 'CUNDINAMARCA-RICAURTE' },
  { label: 'CUNDINAMARCA-SAN ANTONIO DEL TEQUENDAMA' },
  { label: 'CUNDINAMARCA-SAN BERNARDO' },
  { label: 'CUNDINAMARCA-SAN CAYETANO' },
  { label: 'CUNDINAMARCA-SAN FRANCISCO' },
  { label: 'CUNDINAMARCA-SAN JUAN DE RIO SECO' },
  { label: 'CUNDINAMARCA-SASAIMA' },
  { label: 'CUNDINAMARCA-SESQUILE' },
  { label: 'CUNDINAMARCA-SIBATE' },
  { label: 'CUNDINAMARCA-SILVANIA' },
  { label: 'CUNDINAMARCA-SIMIJACA' },
  { label: 'CUNDINAMARCA-SOACHA' },
  { label: 'CUNDINAMARCA-SOPO' },
  { label: 'CUNDINAMARCA-SUBACHOQUE' },
  { label: 'CUNDINAMARCA-SUESCA' },
  { label: 'CUNDINAMARCA-SUPATA' },
  { label: 'CUNDINAMARCA-SUSA' },
  { label: 'CUNDINAMARCA-SUTATAUSA' },
  { label: 'CUNDINAMARCA-TABIO' },
  { label: 'CUNDINAMARCA-TAUSA' },
  { label: 'CUNDINAMARCA-TENA' },
  { label: 'CUNDINAMARCA-TENJO' },
  { label: 'CUNDINAMARCA-TIBACUY' },
  { label: 'CUNDINAMARCA-TIBIRITA' },
  { label: 'CUNDINAMARCA-TOCAIMA' },
  { label: 'CUNDINAMARCA-TOCANCIPA' },
  { label: 'CUNDINAMARCA-TOPAIPI' },
  { label: 'CUNDINAMARCA-UBALA' },
  { label: 'CUNDINAMARCA-UBAQUE' },
  { label: 'CUNDINAMARCA-UNE' },
  { label: 'CUNDINAMARCA-UTICA' },
  { label: 'CUNDINAMARCA-VENECIA' },
  { label: 'CUNDINAMARCA-VERGARA' },
  { label: 'CUNDINAMARCA-VIANI' },
  { label: 'CUNDINAMARCA-VILLA DE SAN DIEGO DE UBATE' },
  { label: 'CUNDINAMARCA-VILLAGOMEZ' },
  { label: 'CUNDINAMARCA-VILLAPINZON' },
  { label: 'CUNDINAMARCA-VILLETA' },
  { label: 'CUNDINAMARCA-VIOTA' },
  { label: 'CUNDINAMARCA-YACOPI' },
  { label: 'CUNDINAMARCA-ZIPACON' },
  { label: 'CUNDINAMARCA-ZIPAQUIRA' },
  { label: 'GUAINIA-BARRANCO MINAS' },
  { label: 'GUAINIA-CACAHUAL' },
  { label: 'GUAINIA-INIRIDA' },
  { label: 'GUAINIA-LA GUADALUPE' },
  { label: 'GUAINIA-MAPIRIPANA' },
  { label: 'GUAINIA-MICHAL' },
  { label: 'GUAINIA-PANA PANA' },
  { label: 'GUAINIA-PUERTO COLOMBIA' },
  { label: 'GUAINIA-SAN FELIPE' },
  { label: 'GUAVIARE-CALAMAR' },
  { label: 'GUAVIARE-EL RETNO' },
  { label: 'GUAVIARE-MIRAFLES' },
  { label: 'GUAVIARE-SAN JOSE DEL GUAVIARE' },
  { label: 'HUILA-ACEVEDO' },
  { label: 'HUILA-AGRADO' },
  { label: 'HUILA-AIPE' },
  { label: 'HUILA-ALGECIRAS' },
  { label: 'HUILA-ALTAMIRA' },
  { label: 'HUILA-BARAYA' },
  { label: 'HUILA-CAMPOALEGRE' },
  { label: 'HUILA-COLOMBIA' },
  { label: 'HUILA-ELIAS' },
  { label: 'HUILA-GARZON' },
  { label: 'HUILA-GIGANTE' },
  { label: 'HUILA-GUADALUPE' },
  { label: 'HUILA-HOBO' },
  { label: 'HUILA-IQUIRA' },
  { label: 'HUILA-ISNOS' },
  { label: 'HUILA-LA ARGENTINA' },
  { label: 'HUILA-LA PLATA' },
  { label: 'HUILA-NATAGA' },
  { label: 'HUILA-NEIVA' },
  { label: 'HUILA-OPAPA' },
  { label: 'HUILA-PAICOL' },
  { label: 'HUILA-PALERMO' },
  { label: 'HUILA-PALESTINA' },
  { label: 'HUILA-PITAL' },
  { label: 'HUILA-PITALITO' },
  { label: 'HUILA-RIVERA' },
  { label: 'HUILA-SALADOBLANCO' },
  { label: 'HUILA-SAN AGUSTIN' },
  { label: 'HUILA-SANTA MARIA' },
  { label: 'HUILA-SUAZA' },
  { label: 'HUILA-TARQUI' },
  { label: 'HUILA-TELLO' },
  { label: 'HUILA-TERUEL' },
  { label: 'HUILA-TESALIA' },
  { label: 'HUILA-TIMANA' },
  { label: 'HUILA-VILLAVIEJA' },
  { label: 'HUILA-YAGUARA' },
  { label: 'LA GUAJIRA-ALBANIA' },
  { label: 'LA GUAJIRA-BARRANCAS' },
  { label: 'LA GUAJIRA-DIBULLA' },
  { label: 'LA GUAJIRA-DISTRACCION' },
  { label: 'LA GUAJIRA-EL MOLINO' },
  { label: 'LA GUAJIRA-FONSECA' },
  { label: 'LA GUAJIRA-HATONUEVO' },
  { label: 'LA GUAJIRA-LA JAGUA DEL PILAR' },
  { label: 'LA GUAJIRA-MAICAO' },
  { label: 'LA GUAJIRA-MANAURE' },
  { label: 'LA GUAJIRA-RIOHACHA' },
  { label: 'LA GUAJIRA-SAN DEL CESAR' },
  { label: 'LA GUAJIRA-URIBIA' },
  { label: 'LA GUAJIRA-URUMITA' },
  { label: 'LA GUAJIRA-VILLANUEVA' },
  { label: 'MAGDALENA-ALGARROBO' },
  { label: 'MAGDALENA-ARACATACA' },
  { label: 'MAGDALENA-ARIGUANI' },
  { label: 'MAGDALENA-CERRO DE SAN ANTONIO' },
  { label: 'MAGDALENA-CHIBOLO' },
  { label: 'MAGDALENA-CIENAGA' },
  { label: 'MAGDALENA-CONCDIA' },
  { label: 'MAGDALENA-EL BANCO' },
  { label: 'MAGDALENA-EL PINON' },
  { label: 'MAGDALENA-EL RETEN' },
  { label: 'MAGDALENA-FUNDACION' },
  { label: 'MAGDALENA-GUAMAL' },
  { label: 'MAGDALENA-NUEVA GRANADA' },
  { label: 'MAGDALENA-PEDRAZA' },
  { label: 'MAGDALENA-PIJINO DEL CARMEN' },
  { label: 'MAGDALENA-PIVIJAY' },
  { label: 'MAGDALENA-PLATO' },
  { label: 'MAGDALENA-PUEBLOVIEJO' },
  { label: 'MAGDALENA-REMOLINO' },
  { label: 'MAGDALENA-SABANAS DE SAN ANGEL' },
  { label: 'MAGDALENA-SALAMINA' },
  { label: 'MAGDALENA-SAN SEBASTIAN DE BUENA VISTA' },
  { label: 'MAGDALENA-SAN ZENON' },
  { label: 'MAGDALENA-SANTA ANA' },
  { label: 'MAGDALENA-SANTA BARBARA DE PINTO' },
  { label: 'MAGDALENA-SANTA MARTA' },
  { label: 'MAGDALENA-SITIONUEVO' },
  { label: 'MAGDALENA-TENERIFE' },
  { label: 'MAGDALENA-ZAPAYAN' },
  { label: 'MAGDALENA-ZONA BANANERA' },
  { label: 'META-ACACIAS' },
  { label: 'META-BARRANCA DE UPIA' },
  { label: 'META-CABUYARO' },
  { label: 'META-CASTILLA LA NUEVA' },
  { label: 'META-CUBARRAL' },
  { label: 'META-CUMARAL' },
  { label: 'META-EL CALVARIO' },
  { label: 'META-EL CASTILLO' },
  { label: 'META-EL DADO' },
  { label: 'META-FUENTE DE O' },
  { label: 'META-GRANADA' },
  { label: 'META-GUAMAL' },
  { label: 'META-LA MACARENA' },
  { label: 'META-LEJANIAS' },
  { label: 'META-MAPIRIPAN' },
  { label: 'META-MESETAS' },
  { label: 'META-PUERTO CONCDIA' },
  { label: 'META-PUERTO GAITAN' },
  { label: 'META-PUERTO LLERAS' },
  { label: 'META-PUERTO LOPEZ' },
  { label: 'META-PUERTO RICO' },
  { label: 'META-RESTREPO' },
  { label: 'META-SAN CARLOS DE GUAROA' },
  { label: 'META-SAN JUAN DE ARAMA' },
  { label: 'META-SAN JUANITO' },
  { label: 'META-SAN MARTIN' },
  { label: 'META-URIBE' },
  { label: 'META-VILLAVICENCIO' },
  { label: 'META-VISTAHERMOSA' },
  { label: 'NARINO-ALBAN' },
  { label: 'NARINO-ALDANA' },
  { label: 'NARINO-ANCUYA' },
  { label: 'NARINO-ARBOLEDA' },
  { label: 'NARINO-BARBACOAS' },
  { label: 'NARINO-BELEN' },
  { label: 'NARINO-BUESACO' },
  { label: 'NARINO-CDOBA' },
  { label: 'NARINO-CHACHAGUI' },
  { label: 'NARINO-COLON' },
  { label: 'NARINO-CONSACA' },
  { label: 'NARINO-CONTADERO' },
  { label: 'NARINO-CUASPUD' },
  { label: 'NARINO-CUMBAL' },
  { label: 'NARINO-CUMBITARA' },
  { label: 'NARINO-EL CHARCO' },
  { label: 'NARINO-EL PENOL' },
  { label: 'NARINO-EL ROSARIO' },
  { label: 'NARINO-EL TABLON DE GOMEZ' },
  { label: 'NARINO-EL TAMBO' },
  { label: 'NARINO-FRANCISCO PIZARRO' },
  { label: 'NARINO-FUNES' },
  { label: 'NARINO-GUACHUCAL' },
  { label: 'NARINO-GUAITARILLA' },
  { label: 'NARINO-GUALMATAN' },
  { label: 'NARINO-ILES' },
  { label: 'NARINO-IMUES' },
  { label: 'NARINO-IPIALES' },
  { label: 'NARINO-LA CRUZ' },
  { label: 'NARINO-LA FLIDA' },
  { label: 'NARINO-LA LLANADA' },
  { label: 'NARINO-LA TOLA' },
  { label: 'NARINO-LA UNION' },
  { label: 'NARINO-LEIVA' },
  { label: 'NARINO-LINARES' },
  { label: 'NARINO-LOS ANDES' },
  { label: 'NARINO-MAGUI' },
  { label: 'NARINO-MALLAMA' },
  { label: 'NARINO-MOSQUERA' },
  { label: 'NARINO-NARINO' },
  { label: 'NARINO-OLAYA HERRERA' },
  { label: 'NARINO-OSPINA' },
  { label: 'NARINO-PASTO' },
  { label: 'NARINO-POLICARPA' },
  { label: 'NARINO-POTOSI' },
  { label: 'NARINO-PROVIDENCIA' },
  { label: 'NARINO-PUERRES' },
  { label: 'NARINO-PUPIALES' },
  { label: 'NARINO-RICAURTE' },
  { label: 'NARINO-ROBERTO PAYAN' },
  { label: 'NARINO-SAMANIEGO' },
  { label: 'NARINO-SAN BERNARDO' },
  { label: 'NARINO-SAN LENZO' },
  { label: 'NARINO-SAN PABLO' },
  { label: 'NARINO-SAN PEDRO DE CARTAGO' },
  { label: 'NARINO-SANDONA' },
  { label: 'NARINO-SANTA BARBARA' },
  { label: 'NARINO-SANTACRUZ' },
  { label: 'NARINO-SAPUYES' },
  { label: 'NARINO-TAMINANGO' },
  { label: 'NARINO-TANGUA' },
  { label: 'NARINO-TUMACO' },
  { label: 'NARINO-TUQUERRES' },
  { label: 'NARINO-YACUANQUER' },
  { label: 'NTE DE SANTANDER-ABREGO' },
  { label: 'NTE DE SANTANDER-ARBOLEDAS' },
  { label: 'NTE DE SANTANDER-BOCHALEMA' },
  { label: 'NTE DE SANTANDER-BUCARASICA' },
  { label: 'NTE DE SANTANDER-CACHIRA' },
  { label: 'NTE DE SANTANDER-CACOTA' },
  { label: 'NTE DE SANTANDER-CHINACOTA' },
  { label: 'NTE DE SANTANDER-CHITAGA' },
  { label: 'NTE DE SANTANDER-CONVENCION' },
  { label: 'NTE DE SANTANDER-CUCUTA' },
  { label: 'NTE DE SANTANDER-CUCUTILLA' },
  { label: 'NTE DE SANTANDER-DURANIA' },
  { label: 'NTE DE SANTANDER-EL CARMEN' },
  { label: 'NTE DE SANTANDER-EL TARRA' },
  { label: 'NTE DE SANTANDER-EL ZULIA' },
  { label: 'NTE DE SANTANDER-GRAMALOTE' },
  { label: 'NTE DE SANTANDER-HACARI' },
  { label: 'NTE DE SANTANDER-HERRAN' },
  { label: 'NTE DE SANTANDER-LA ESPERANZA' },
  { label: 'NTE DE SANTANDER-LA PLAYA' },
  { label: 'NTE DE SANTANDER-LABATECA' },
  { label: 'NTE DE SANTANDER-LOS PATIOS' },
  { label: 'NTE DE SANTANDER-LOURDES' },
  { label: 'NTE DE SANTANDER-MUTISCUA' },
  { label: 'NTE DE SANTANDER-OCANA' },
  { label: 'NTE DE SANTANDER-PAMPLONA' },
  { label: 'NTE DE SANTANDER-PAMPLONITA' },
  { label: 'NTE DE SANTANDER-PUERTO' },
  { label: 'NTE DE SANTANDER-RAGONVALIA' },
  { label: 'NTE DE SANTANDER-SALAZAR' },
  { label: 'NTE DE SANTANDER-SAN CALIXTO' },
  { label: 'NTE DE SANTANDER-SAN CAYETANO' },
  { label: 'NTE DE SANTANDER-SANTIAGO' },
  { label: 'NTE DE SANTANDER-SARDINATA' },
  { label: 'NTE DE SANTANDER-SILOS' },
  { label: 'NTE DE SANTANDER-TEAMA' },
  { label: 'NTE DE SANTANDER-TIBU' },
  { label: 'NTE DE SANTANDER-TOLEDO' },
  { label: 'NTE DE SANTANDER-VILLA CARO' },
  { label: 'NTE DE SANTANDER-VILLA DEL ROSARIO' },
  { label: 'PUTUMAYO-COLON' },
  { label: 'PUTUMAYO-ITO' },
  { label: 'PUTUMAYO-LEGUIZAMO' },
  { label: 'PUTUMAYO-MOCOA' },
  { label: 'PUTUMAYO-PUERTO ASIS' },
  { label: 'PUTUMAYO-PUERTO CAICEDO' },
  { label: 'PUTUMAYO-PUERTO GUZMAN' },
  { label: 'PUTUMAYO-SAN FRANCISCO' },
  { label: 'PUTUMAYO-SAN MIGUEL' },
  { label: 'PUTUMAYO-SANTIAGO' },
  { label: 'PUTUMAYO-SIBUNDOY' },
  { label: 'PUTUMAYO-VALLE DEL GUAMUEZ' },
  { label: 'PUTUMAYO-VILLAGARZON' },
  { label: 'QUINDIO-ARMENIA' },
  { label: 'QUINDIO-BUENAVISTA' },
  { label: 'QUINDIO-CALARCA' },
  { label: 'QUINDIO-CDOBA' },
  { label: 'QUINDIO-CIRCASIA' },
  { label: 'QUINDIO-FILANDIA' },
  { label: 'QUINDIO-GENOVA' },
  { label: 'QUINDIO-LA TEBAIDA' },
  { label: 'QUINDIO-MONTENEGRO' },
  { label: 'QUINDIO-PIJAO' },
  { label: 'QUINDIO-QUIMBAYA' },
  { label: 'QUINDIO-SALENTO' },
  { label: 'RISARALDA-APIA' },
  { label: 'RISARALDA-BALBOA' },
  { label: 'RISARALDA-BELEN DE UMBRIA' },
  { label: 'RISARALDA-DOSQUEBRADAS' },
  { label: 'RISARALDA-GUATICA' },
  { label: 'RISARALDA-LA CELIA' },
  { label: 'RISARALDA-LA VIRGINIA' },
  { label: 'RISARALDA-MARSELLA' },
  { label: 'RISARALDA-MISTRATO' },
  { label: 'RISARALDA-PEREIRA' },
  { label: 'RISARALDA-PUEBLO RICO' },
  { label: 'RISARALDA-QUINCHIA' },
  { label: 'RISARALDA-SANTA ROSA DE CABAL' },
  { label: 'RISARALDA-SANTUARIO' },
  { label: 'SAN ANDRES PROVIDENCIA Y STA-PROVIDENCIA' },
  { label: 'SAN ANDRES PROVIDENCIA Y STA-SAN ANDRES' },
  { label: 'SANTANDER-AGUADA' },
  { label: 'SANTANDER-ALBANIA' },
  { label: 'SANTANDER-ARATOCA' },
  { label: 'SANTANDER-BARBOSA' },
  { label: 'SANTANDER-BARICHARA' },
  { label: 'SANTANDER-BARRANCABERMEJA' },
  { label: 'SANTANDER-BETULIA' },
  { label: 'SANTANDER-BOLIVAR' },
  { label: 'SANTANDER-BUCARAMANGA' },
  { label: 'SANTANDER-CABRERA' },
  { label: 'SANTANDER-CALIFNIA' },
  { label: 'SANTANDER-CAPITANEJO' },
  { label: 'SANTANDER-CARCASI' },
  { label: 'SANTANDER-CEPITA' },
  { label: 'SANTANDER-CERRITO' },
  { label: 'SANTANDER-CHARALA' },
  { label: 'SANTANDER-CHARTA' },
  { label: 'SANTANDER-CHIMA' },
  { label: 'SANTANDER-CHIPATA' },
  { label: 'SANTANDER-CIMITARRA' },
  { label: 'SANTANDER-COMO' },
  { label: 'SANTANDER-CONCEPCION' },
  { label: 'SANTANDER-CONFINES' },
  { label: 'SANTANDER-CONTRATACION' },
  { label: 'SANTANDER-CURITI' },
  { label: 'SANTANDER-EL CARMEN DE CHUCURI' },
  { label: 'SANTANDER-EL GUACAMAYO' },
  { label: 'SANTANDER-EL PENON' },
  { label: 'SANTANDER-EL PLAYON' },
  { label: 'SANTANDER-ENCINO' },
  { label: 'SANTANDER-ENCISO' },
  { label: 'SANTANDER-FLIAN' },
  { label: 'SANTANDER-FLIDABLANCA' },
  { label: 'SANTANDER-GALAN' },
  { label: 'SANTANDER-GAMBITA' },
  { label: 'SANTANDER-GIRON' },
  { label: 'SANTANDER-GUACA' },
  { label: 'SANTANDER-GUADALUPE' },
  { label: 'SANTANDER-GUAPOTA' },
  { label: 'SANTANDER-GUAVATA' },
  { label: 'SANTANDER-GUEPSA' },
  { label: 'SANTANDER-HATO' },
  { label: 'SANTANDER-JDAN' },
  { label: 'SANTANDER-JESUS MARIA' },
  { label: 'SANTANDER-LA BELLEZA' },
  { label: 'SANTANDER-LA PAZ' },
  { label: 'SANTANDER-LANDAZURI' },
  { label: 'SANTANDER-LEBRIJA' },
  { label: 'SANTANDER-LOS SANTOS' },
  { label: 'SANTANDER-MACARAVITA' },
  { label: 'SANTANDER-MALAGA' },
  { label: 'SANTANDER-MATANZA' },
  { label: 'SANTANDER-MOGOTES' },
  { label: 'SANTANDER-MOLAGAVITA' },
  { label: 'SANTANDER-OCAMONTE' },
  { label: 'SANTANDER-OIBA' },
  { label: 'SANTANDER-ONZAGA' },
  { label: 'SANTANDER-PALMAR' },
  { label: 'SANTANDER-PALMAS DEL SOCRO' },
  { label: 'SANTANDER-PARAMO' },
  { label: 'SANTANDER-PIEDECUESTA' },
  { label: 'SANTANDER-PINCHOTE' },
  { label: 'SANTANDER-PUENTE NACIONAL' },
  { label: 'SANTANDER-PUERTO PARRA' },
  { label: 'SANTANDER-PUERTO WILCHES' },
  { label: 'SANTANDER-RIONEGRO' },
  { label: 'SANTANDER-SABANA DE TRES' },
  { label: 'SANTANDER-SAN ANDRES' },
  { label: 'SANTANDER-SAN BENITO' },
  { label: 'SANTANDER-SAN GIL' },
  { label: 'SANTANDER-SAN JOAQUIN' },
  { label: 'SANTANDER-SAN JOSE DE MIRANDA' },
  { label: 'SANTANDER-SAN MIGUEL' },
  { label: 'SANTANDER-SAN VICENTE DE CHUCURI' },
  { label: 'SANTANDER-SANTA BARBARA' },
  { label: 'SANTANDER-SANTA HELENA DEL OPON' },
  { label: 'SANTANDER-SIMACOTA' },
  { label: 'SANTANDER-SOCRO' },
  { label: 'SANTANDER-SUAITA' },
  { label: 'SANTANDER-SUCRE' },
  { label: 'SANTANDER-SURATA' },
  { label: 'SANTANDER-TONA' },
  { label: 'SANTANDER-VALLE DE SAN JOSE' },
  { label: 'SANTANDER-VELEZ' },
  { label: 'SANTANDER-VETAS' },
  { label: 'SANTANDER-VILLANUEVA' },
  { label: 'SANTANDER-ZAPATOCA' },
  { label: 'SUCRE-BUENAVISTA' },
  { label: 'SUCRE-CAIMITO' },
  { label: 'SUCRE-CHALAN' },
  { label: 'SUCRE-COLOSO' },
  { label: 'SUCRE-COVENAS' },
  { label: 'SUCRE-COZAL' },
  { label: 'SUCRE-EL ROBLE' },
  { label: 'SUCRE-GALERAS' },
  { label: 'SUCRE-GUARANDA' },
  { label: 'SUCRE-LA UNION' },
  { label: 'SUCRE-LOS PALMITOS' },
  { label: 'SUCRE-MAJAGUAL' },
  { label: 'SUCRE-MROA' },
  { label: 'SUCRE-OVEJAS' },
  { label: 'SUCRE-PALMITO' },
  { label: 'SUCRE-SAMPUES' },
  { label: 'SUCRE-SAN BENITO ABAD' },
  { label: 'SUCRE-SAN JUAN DE BETULIA' },
  { label: 'SUCRE-SAN MARCOS' },
  { label: 'SUCRE-SAN ONOFRE' },
  { label: 'SUCRE-SAN PEDRO' },
  { label: 'SUCRE-SANTIAGO DE TOLU' },
  { label: 'SUCRE-SINCE' },
  { label: 'SUCRE-SINCELEJO' },
  { label: 'SUCRE-SUCRE' },
  { label: 'SUCRE-TOLU VIEJO' },
  { label: 'TOLIMA-ALPUJARRA' },
  { label: 'TOLIMA-ALVARADO' },
  { label: 'TOLIMA-AMBALEMA' },
  { label: 'TOLIMA-ANZOATEGUI' },
  { label: 'TOLIMA-ARMERO' },
  { label: 'TOLIMA-ATACO' },
  { label: 'TOLIMA-CAJAMARCA' },
  { label: 'TOLIMA-CARMEN DE APICALA' },
  { label: 'TOLIMA-CASABIANCA' },
  { label: 'TOLIMA-CHAPARRAL' },
  { label: 'TOLIMA-COELLO' },
  { label: 'TOLIMA-COYAIMA' },
  { label: 'TOLIMA-CUNDAY' },
  { label: 'TOLIMA-DOLES' },
  { label: 'TOLIMA-ESPINAL' },
  { label: 'TOLIMA-FALAN' },
  { label: 'TOLIMA-FLANDES' },
  { label: 'TOLIMA-FRESNO' },
  { label: 'TOLIMA-GUAMO' },
  { label: 'TOLIMA-HERVEO' },
  { label: 'TOLIMA-HONDA' },
  { label: 'TOLIMA-IBAGUE' },
  { label: 'TOLIMA-ICONONZO' },
  { label: 'TOLIMA-LERIDA' },
  { label: 'TOLIMA-LIBANO' },
  { label: 'TOLIMA-MELGAR' },
  { label: 'TOLIMA-MURILLO' },
  { label: 'TOLIMA-NATAGAIMA' },
  { label: 'TOLIMA-PALOCABILDO' },
  { label: 'TOLIMA-PIEDRAS' },
  { label: 'TOLIMA-PLANADAS' },
  { label: 'TOLIMA-PRADO' },
  { label: 'TOLIMA-PURIFICACION' },
  { label: 'TOLIMA-RIOBLANCO' },
  { label: 'TOLIMA-RONCESVALLES' },
  { label: 'TOLIMA-ROVIRA' },
  { label: 'TOLIMA-SALDANA' },
  { label: 'TOLIMA-SAN ANTONIO' },
  { label: 'TOLIMA-SAN LUIS' },
  { label: 'TOLIMA-SAN SEBASTIAN DE MARIQUITA' },
  { label: 'TOLIMA-SANTA ISABEL' },
  { label: 'TOLIMA-SUAREZ' },
  { label: 'TOLIMA-TEGA' },
  { label: 'TOLIMA-VALLE DE SAN JUAN' },
  { label: 'TOLIMA-VENADILLO' },
  { label: 'TOLIMA-VILLAHERMOSA' },
  { label: 'TOLIMA-VILLARRICA' },
  { label: 'VALLE DEL CAUCA-ALCALA' },
  { label: 'VALLE DEL CAUCA-ANDALUCIA' },
  { label: 'VALLE DEL CAUCA-ANSERMANUEVO' },
  { label: 'VALLE DEL CAUCA-ARGELIA' },
  { label: 'VALLE DEL CAUCA-BOLIVAR' },
  { label: 'VALLE DEL CAUCA-BUENAVENTURA' },
  { label: 'VALLE DEL CAUCA-BUGALAGRANDE' },
  { label: 'VALLE DEL CAUCA-CAICEDONIA' },
  { label: 'VALLE DEL CAUCA-CALIMA' },
  { label: 'VALLE DEL CAUCA-CANDELARIA' },
  { label: 'VALLE DEL CAUCA-CARTAGO' },
  { label: 'VALLE DEL CAUCA-DAGUA' },
  { label: 'VALLE DEL CAUCA-EL AGUILA' },
  { label: 'VALLE DEL CAUCA-EL CAIRO' },
  { label: 'VALLE DEL CAUCA-EL CERRITO' },
  { label: 'VALLE DEL CAUCA-EL DOVIO' },
  { label: 'VALLE DEL CAUCA-FLIDA' },
  { label: 'VALLE DEL CAUCA-GINEBRA' },
  { label: 'VALLE DEL CAUCA-GUACARI' },
  { label: 'VALLE DEL CAUCA-GUADALAJARA DE BUGA' },
  { label: 'VALLE DEL CAUCA-JAMUNDI' },
  { label: 'VALLE DEL CAUCA-LA CUMBRE' },
  { label: 'VALLE DEL CAUCA-LA UNION' },
  { label: 'VALLE DEL CAUCA-LA VICTIA' },
  { label: 'VALLE DEL CAUCA-OBANDO' },
  { label: 'VALLE DEL CAUCA-PALMIRA' },
  { label: 'VALLE DEL CAUCA-PRADERA' },
  { label: 'VALLE DEL CAUCA-RESTREPO' },
  { label: 'VALLE DEL CAUCA-RIOFRIO' },
  { label: 'VALLE DEL CAUCA-ROLDANILLO' },
  { label: 'VALLE DEL CAUCA-SAN PEDRO' },
  { label: 'VALLE DEL CAUCA-SANTIAGO DE CALI' },
  { label: 'VALLE DEL CAUCA-SEVILLA' },
  { label: 'VALLE DEL CAUCA-TO' },
  { label: 'VALLE DEL CAUCA-TRUJILLO' },
  { label: 'VALLE DEL CAUCA-TULUA' },
  { label: 'VALLE DEL CAUCA-ULLOA' },
  { label: 'VALLE DEL CAUCA-VERSALLES' },
  { label: 'VALLE DEL CAUCA-VIJES' },
  { label: 'VALLE DEL CAUCA-YOTOCO' },
  { label: 'VALLE DEL CAUCA-YUMBO' },
  { label: 'VALLE DEL CAUCA-ZARZAL' },
  { label: 'VAUPES-CARURU' },
  { label: 'VAUPES-MITU' },
  { label: 'VAUPES-PACOA' },
  { label: 'VAUPES-PAPUNAUA' },
  { label: 'VAUPES-TARAIRA' },
  { label: 'VAUPES-YAVARATE' },
  { label: 'VICHADA-CUMARIBO' },
  { label: 'VICHADA-LA PRIMAVERA' },
  { label: 'VICHADA-PUERTO CARRENO' },
  { label: 'VICHADA-SANTA ROSALIA' },
];

export const internationalCities = [
  { label: 'ALEMANIA-ALTENBURG-ALTENBURG-NOBITZ' },
  { label: 'ALEMANIA-BAYREUTH' },
  { label: 'ALEMANIA-BERLÍN-TODOS LOS AEROPUERTOS' },
  { label: 'ALEMANIA-BONN' },
  { label: 'ALEMANIA-BONN-COLONIA BONN' },
  { label: 'ALEMANIA-BORKUM' },
  { label: 'ALEMANIA-BREMEN' },
  { label: 'ALEMANIA-COLONIA' },
  { label: 'ALEMANIA-DORTMUND' },
  { label: 'ALEMANIA-DRESDE' },
  { label: 'ALEMANIA-DÜSSELDORF' },
  { label: 'ALEMANIA-DÜSSELDORF-DÜSSELDORF' },
  { label: 'ALEMANIA-DÜSSELDORF-MÖNCHENGLADBACH' },
  { label: 'ALEMANIA-ERFURT' },
  { label: 'ALEMANIA-FRANKFURT-FRANKFURT' },
  { label: 'ALEMANIA-FRANKFURT-HAHN' },
  { label: 'ALEMANIA-FRIEDRICHSHAFEN' },
  { label: 'ALEMANIA-HAMBURGO-FL' },
  { label: 'ALEMANIA-HANÓVER' },
  { label: 'ALEMANIA-HERINGSDORF' },
  { label: 'ALEMANIA-HOF' },
  { label: 'ALEMANIA-JUIST' },
  { label: 'ALEMANIA-KARLSRUHE/BADEN BADEN' },
  { label: 'ALEMANIA-KASSEL-KASSEL-CALDEN' },
  { label: 'ALEMANIA-KIEL-KIEL-HOLTENAU' },
  { label: 'ALEMANIA-LAHR-LAHR' },
  { label: 'ALEMANIA-LANGEOOG-LANGEOOG' },
  { label: 'ALEMANIA-LEIPZIG' },
  { label: 'ALEMANIA-MAGDEBURGO-COCHSTEDT' },
  { label: 'ALEMANIA-MANNHEIM' },
  { label: 'ALEMANIA-MEMMINGEN-MEMMINGEN ALLGÄU' },
  { label: 'ALEMANIA-MÜNSTER' },
  { label: 'ALEMANIA-NORDERNEY' },
  { label: 'ANGUILA-ANGUILLA-ROLLANG FIELD' },
  { label: 'ANTÁRTIDA-MARGUERITE BAY-MARGUERITE BAY' },
  { label: 'ARGENTINA-ALTO RIO SENGUERR' },
  { label: 'ARGENTINA-BAHIA BLANCA' },
  { label: 'ARGENTINA-BANGALORE-KEMPEGOWDA INTERNATI' },
  { label: 'ARGENTINA-BRAGADO' },
  { label: 'ARGENTINA-BUENOS AIRES' },
  { label: 'ARGENTINA-BUENOS AIRES-JORGE NEWBERY' },
  { label: 'ARGENTINA-CALETA OLIVIA' },
  { label: 'ARGENTINA-CAMODORO' },
  { label: 'ARGENTINA-CARMEN DE PATAGONES' },
  { label: 'ARGENTINA-CATAMARCA' },
  { label: 'ARGENTINA-CERES' },
  { label: 'ARGENTINA-CHARATA' },
  { label: 'ARGENTINA-CHARLESTON' },
  { label: 'ARGENTINA-CHARLOTTE' },
  { label: 'ARGENTINA-CHIMBOTE-TENIENTE FAP JAIME A' },
  { label: 'ARGENTINA-CHOS MALAL' },
  { label: 'ARGENTINA-CLORINDA' },
  { label: 'ARGENTINA-CONCORDIA' },
  { label: 'ARGENTINA-CORDOBA' },
  { label: 'ARGENTINA-CORONEL SUAREZ' },
  { label: 'ARGENTINA-CORRIENTES' },
  { label: 'ARGENTINA-CURUZU CUATIA' },
  { label: 'ARGENTINA-CUTRAL-CO' },
  { label: 'ARGENTINA-EL BOLSAN' },
  { label: 'ARGENTINA-EL CALAFATE' },
  { label: 'ARGENTINA-EL DORADO' },
  { label: 'ARGENTINA-EL MAITEN' },
  { label: 'ARGENTINA-EL PALOMAR' },
  { label: 'ARGENTINA-ESQUEL' },
  { label: 'ARGENTINA-FORMOSA' },
  { label: 'ARGENTINA-GENERAL PICO' },
  { label: 'ARGENTINA-GENERAL ROCA' },
  { label: 'ARGENTINA-GENERAL VILLEGAS' },
  { label: 'ARGENTINA-GOBERNADOR GREGORES' },
  { label: 'ARGENTINA-GOYA' },
  { label: 'ARGENTINA-GUALEGUAYCHU' },
  { label: 'ARGENTINA-IGUAZU' },
  { label: 'ARGENTINA-INGENIERO JACOBACCI' },
  { label: 'ARGENTINA-JOSE DE SAN MARTIN' },
  { label: 'ARGENTINA-JUJUY' },
  { label: 'ARGENTINA-JUNIN' },
  { label: 'ARGENTINA-LA CUMBRE' },
  { label: 'ARGENTINA-LA PLATA' },
  { label: 'ARGENTINA-LA RIOJA' },
  { label: 'ARGENTINA-LAFONTAINE' },
  { label: 'ARGENTINA-LAGO ARGENTINA' },
  { label: 'ARGENTINA-LAS HERAS' },
  { label: 'ARGENTINA-LAS LOMITAS' },
  { label: 'ARGENTINA-LONCOPUE' },
  { label: 'ARGENTINA-LOS MENUCOS' },
  { label: 'ARGENTINA-MALARGUE' },
  { label: 'ARGENTINA-MAQUINCHAO' },
  { label: 'ARGENTINA-MAR DEL PLATA' },
  { label: 'ARGENTINA-MENDOZA' },
  { label: 'ARGENTINA-MERCEDES' },
  { label: 'ARGENTINA-MERLO' },
  { label: 'ARGENTINA-MIRAMAR' },
  { label: 'ARGENTINA-MONTE CASEROS' },
  { label: 'ARGENTINA-NECOCHEA' },
  { label: 'ARGENTINA-NEUQUEN' },
  { label: 'ARGENTINA-OLAVARRIA' },
  { label: 'ARGENTINA-ORÁN' },
  { label: 'ARGENTINA-PARA CHINAR' },
  { label: 'ARGENTINA-PARANA' },
  { label: 'ARGENTINA-PASO DE LOS LIBRES' },
  { label: 'ARGENTINA-PEHUAJÓ' },
  { label: 'ARGENTINA-PERITO MORENO' },
  { label: 'ARGENTINA-POSADAS' },
  { label: 'ARGENTINA-PRES. ROQUE SAENZ PENA' },
  { label: 'ARGENTINA-PUERTO DESEADO' },
  { label: 'ARGENTINA-PUERTO MADRYN' },
  { label: 'ARGENTINA-RECONQUISTA' },
  { label: 'ARGENTINA-RESISTENCIA' },
  { label: 'ARGENTINA-RINCON DE LOS SAUCES' },
  { label: 'ARGENTINA-RIO CUARTO' },
  { label: 'ARGENTINA-RIO GALLEGOS' },
  { label: 'ARGENTINA-RIO GRANDE' },
  { label: 'ARGENTINA-RIO MAYO' },
  { label: 'ARGENTINA-RIO TURBIO' },
  { label: 'ARGENTINA-ROSARIO' },
  { label: 'ARGENTINA-SALTA' },
  { label: 'ARGENTINA-SAN ANTONIO OESTA' },
  { label: 'ARGENTINA-SAN CARLOS' },
  { label: 'ARGENTINA-SAN FERNANDO' },
  { label: 'ARGENTINA-SAN JUAN' },
  { label: 'ARGENTINA-SAN JULIAN' },
  { label: 'ARGENTINA-SAN LUIS' },
  { label: 'ARGENTINA-SAN MARTIN DE LOS ANDES' },
  { label: 'ARGENTINA-SAN RAFAEL' },
  { label: 'ARGENTINA-SANTA CRUZ' },
  { label: 'ARGENTINA-SANTA CRUZ DO SUL-SANTA CRUZ D' },
  { label: 'ARGENTINA-SANTA FE' },
  { label: 'ARGENTINA-SANTA ROSA' },
  { label: 'ARGENTINA-SANTA TERESITA' },
  { label: 'ARGENTINA-SANTIAGO DEL ESTERO' },
  { label: 'ARGENTINA-SÃO PAULO DE OLIVENÇA-SENADORA' },
  { label: 'ARGENTINA-SARMIENTO' },
  { label: 'ARGENTINA-SIERRA GRANDE' },
  { label: 'ARGENTINA-SUNCHALES' },
  { label: 'ARGENTINA-TANDIL' },
  { label: 'ARGENTINA-TARTAGAL' },
  { label: 'ARGENTINA-TERMAS DE RÍO' },
  { label: 'ARGENTINA-TRELEW' },
  { label: 'ARGENTINA-TRES ARROYOS' },
  { label: 'ARGENTINA-TUCUMAN' },
  { label: 'ARGENTINA-USHUAIA' },
  { label: 'ARGENTINA-VALCHETA' },
  { label: 'ARGENTINA-VIEDMA' },
  { label: 'ARGENTINA-VILLA DOLORES' },
  { label: 'ARGENTINA-VILLA GESELL' },
  { label: 'ARGENTINA-VILLA MERCEDES' },
  { label: 'ARGENTINA-ZAPALA' },
  { label: 'AUSTRALIA-SOLOMON AERODROME-SOLOMON AERO' },
  { label: 'BAHAMAS-ROTUNDA-ROTUNDA' },
  { label: 'BÉLGICA-BRUSELAS (BRUSSELS AIRPORT)' },
  { label: 'BÉLGICA-CHARLEROI (BRUSSELS SOUTH CHARLEROI)' },
  { label: 'BÉLGICA-OSTENDE (OSTEND-BRUGES INTERNATIONAL)' },
  { label: 'BÉLGICA-WEVELGEM (KORTRIJK-WEVELGEM)' },
  { label: 'BÉLGICA-AMBERES (ANTWERP-DEURNE)' },
  { label: 'BÉLGICA-LIEJA (LIÈGE AIRPORT)' },
  { label: 'BRASIL-ALEGRETE-ALEGRETE NOVO' },
  { label: 'BRASIL-ALENQUER-ALENQUER' },
  { label: 'BRASIL-ALMENARA-CIRILO QUEIRÓZ' },
  { label: 'BRASIL-ALTA FLORESTA-PILOTO OSVALDO M' },
  { label: 'BRASIL-ALTAMIRA' },
  { label: 'BRASIL-ANÁPOLIS-ANÁPOLIS' },
  { label: 'BRASIL-APUCARANA-APUCARANA' },
  { label: 'BRASIL-ARACATUBA' },
  { label: 'BRASIL-ARAGARÇAS-ESTÂNCIA DAS CASCATA' },
  { label: 'BRASIL-ARAGUAINA' },
  { label: 'BRASIL-ARAPIRACA-ARAPIRACA' },
  { label: 'BRASIL-ARAPONGAS-ARAPONGAS' },
  { label: 'BRASIL-ARARAQUARA-ARARAQUARA' },
  { label: 'BRASIL-ARAXÁ-ROMEU ZEMA' },
  { label: 'BRASIL-ARIPUANÃ-ARIPUANÃ' },
  { label: 'BRASIL-ARIQUEMES-NOVA VIDA' },
  { label: 'BRASIL-ARRAIAS-ARRAIAS' },
  { label: 'BRASIL-ASSIS-MARCELO PIRES HALZHAUSEN' },
  { label: 'BRASIL-BAGÉ-COMANDANTE GUSTAVO KRAEME' },
  { label: 'BRASIL-BALSAS-BALSAS' },
  { label: 'BRASIL-BARCELOS-BARCELOS' },
  { label: 'BRASIL-BARRA DO CORDA-BARRA DO CORDA' },
  { label: 'BRASIL-BARRA DO GARÇAS-BARRA DO GARÇA' },
  { label: 'BRASIL-BARRA-BARRA' },
  { label: 'BRASIL-BARREIRAS' },
  { label: 'BRASIL-BARREIRINHAS-BARREIRINHAS' },
  { label: 'BRASIL-BARRETOS-CHAFEI AMSEI' },
  { label: 'BRASIL-BAURU-BAURU' },
  { label: 'BRASIL-BELEM' },
  { label: 'BRASIL-BELMONTE-BELMONTE' },
  { label: 'BRASIL-BELO HORIZONTE-PAMPULHA' },
  { label: 'BRASIL-BLUMENAU-BLUMENAU' },
  { label: 'BRASIL-BOCA DO ACRE-NOVO CAMPO' },
  { label: 'BRASIL-BOM JESUS DA LAPA-BOM JESUS DA' },
  { label: 'BRASIL-BONITO-BONITO' },
  { label: 'BRASIL-BORBA-BORBA' },
  { label: 'BRASIL-BRAGANÇA PAULISTA-ESTADUAL ART' },
  { label: 'BRASIL-BREVES-BREVES' },
  { label: 'BRASIL-BRUMADO-SÓCRATES MARIANI BITTE' },
  { label: 'BRASIL-CABO FRIO-CABO FRIO' },
  { label: 'BRASIL-CABO FRIO-UMBERTO' },
  { label: 'BRASIL-CAÇADOR-CAÇADOR' },
  { label: 'BRASIL-CÁCERES-CÁCERES' },
  { label: 'BRASIL-CACHOEIRO DO ITAPEMIRIM-CACHOE' },
  { label: 'BRASIL-CACOAL-CACOAL' },
  { label: 'BRASIL-CALDAS NOVAS-NELSON RIBEIRO GU' },
  { label: 'BRASIL-CAMETÁ-NEW CAMETÁ' },
  { label: 'BRASIL-CAMOCIM-CAMOCIM' },
  { label: 'BRASIL-CAMPINA GRANDE' },
  { label: 'BRASIL-CAMPINAS' },
  { label: 'BRASIL-CAMPO MOURÃO-CAMPO MOURÃO' },
  { label: 'BRASIL-CAMPOS' },
  { label: 'BRASIL-CANARANA-CANARANA' },
  { label: 'BRASIL-CANAVIEIRAS-SÓCRATES REZENDE' },
  { label: 'BRASIL-CARAJAS' },
  { label: 'BRASIL-CARAUARI-CARAUARI' },
  { label: 'BRASIL-CARAVELAS-CARAVELAS' },
  { label: 'BRASIL-CAROLINA-BRIG. LYSIAS AUGUSTO' },
  { label: 'BRASIL-CARUARU-CARUARU' },
  { label: 'BRASIL-CARUTAPERA-CARUTAPERA' },
  { label: 'BRASIL-CASCAVEL' },
  { label: 'BRASIL-CASSILÂNDIA-CASSILÂNDIA' },
  { label: 'BRASIL-CATALÃO-CATALÃO' },
  { label: 'BRASIL-CAXIAS DO SUL' },
  { label: 'BRASIL-CHAPECO' },
  { label: 'BRASIL-COARI-COARI' },
  { label: 'BRASIL-CONCEIÇÃO DO ARAGUAIA-CONCEIÇÃ' },
  { label: 'BRASIL-CONCÓRDIA-CONCÓRDIA' },
  { label: 'BRASIL-CONFRESA-CONFRESA' },
  { label: 'BRASIL-CORUMBA' },
  { label: 'BRASIL-COSTA MARQUES-COSTA MARQUES' },
  { label: 'BRASIL-CRICIUMA' },
  { label: 'BRASIL-CRUZ ALTA-CARLOS RUHL' },
  { label: 'BRASIL-CRUZEIRO DO SUL' },
  { label: 'BRASIL-CUIABA' },
  { label: 'BRASIL-CURITIBA' },
  { label: 'BRASIL-CURITIBA-BACACHERI' },
  { label: 'BRASIL-CURURUPU-CURURUPU' },
  { label: 'BRASIL-DIAMANTINA-DIAMANTINA' },
  { label: 'BRASIL-DIAMANTINO-DIAMANTINO' },
  { label: 'BRASIL-DIANÓPOLIS-DIANÓPOLIS' },
  { label: 'BRASIL-DIVINÓPOLIS-BRIGADEIRO CABRAL' },
  { label: 'BRASIL-DOURADOS' },
  { label: 'BRASIL-EIRUNEPÉ-EIRUNEPÉ' },
  { label: 'BRASIL-ERECHIM-ERECHIM' },
  { label: 'BRASIL-ESPINOSA-ESPINOSA' },
  { label: 'BRASIL-FEIRA DE SANTANA-JOÃO DURVAL C' },
  { label: 'BRASIL-FERNANDO DE NORONHA' },
  { label: 'BRASIL-FLORIANO-CANGAPARA' },
  { label: 'BRASIL-FONTE BOA-FONTE BOA' },
  { label: 'BRASIL-FRANCA' },
  { label: 'BRASIL-FRANCISCO BELTRÃO-FRANCISCO BE' },
  { label: 'BRASIL-GOIANIA' },
  { label: 'BRASIL-GOVERNADOR VALADARES' },
  { label: 'BRASIL-GUAJARÁ-MIRIM-GUAJARÁ-MIRIM' },
  { label: 'BRASIL-GUANAMBI-GUANAMBI' },
  { label: 'BRASIL-GUARAPARI-GUARAPARI' },
  { label: 'BRASIL-GUARAPUAVA-TANCREDO THOMAS DE' },
  { label: 'BRASIL-GUARATINGUETÁ-GUARATINGUETÁ' },
  { label: 'BRASIL-GURUPI-GURUPI' },
  { label: 'BRASIL-IGUASSU FALLS' },
  { label: 'BRASIL-IJUÍ-IJUÍ' },
  { label: 'BRASIL-ILHEUS' },
  { label: 'BRASIL-IMPERATRIZ' },
  { label: 'BRASIL-IPATINGA' },
  { label: 'BRASIL-IRECÊ-IRECÊ' },
  { label: 'BRASIL-ITACOATIARA-ITACOATIARA' },
  { label: 'BRASIL-ITAITUBA' },
  { label: 'BRASIL-ITAPERUNA-ITAPERUNA' },
  { label: 'BRASIL-JACAREACANGA' },
  { label: 'BRASIL-JEQUIÉ-JEQUIÉ' },
  { label: 'BRASIL-JIJOCA DE JERICOACOARA-JERICOA' },
  { label: 'BRASIL-JIPARANA' },
  { label: 'BRASIL-JUAZEIRO DO NORTE' },
  { label: 'BRASIL-JUÍNA-JUÍNA' },
  { label: 'BRASIL-JUIZ DE FORA-ZONA DA MATA' },
  { label: 'BRASIL-JURUENA-JURUENA' },
  { label: 'BRASIL-LÁBREA-LÁBREA' },
  { label: 'BRASIL-LAGES' },
  { label: 'BRASIL-LENÇÓIS-CORONEL HORÁCIO DE MAT' },
  { label: 'BRASIL-LONDRINA' },
  { label: 'BRASIL-LUCAS DO RIO VERDE-MUNICIPAL B' },
  { label: 'BRASIL-MACAÉ-MACAÉ' },
  { label: 'BRASIL-MACAPA' },
  { label: 'BRASIL-MACEIO' },
  { label: 'BRASIL-MANAUS' },
  { label: 'BRASIL-MANAUS-PONTA PELADA' },
  { label: 'BRASIL-MANICORÉ-MANICORÉ' },
  { label: 'BRASIL-MARABA' },
  { label: 'BRASIL-MARILIA' },
  { label: 'BRASIL-MARINGA' },
  { label: 'BRASIL-MATUPÁ-REGIONAL ORLANDO VILLAS' },
  { label: 'BRASIL-MAUÉS-MAUÉS' },
  { label: 'BRASIL-MINAÇU-MINAÇU' },
  { label: 'BRASIL-MONTE ALEGRE-MONTE ALEGRE' },
  { label: 'BRASIL-MONTE DOURADO' },
  { label: 'BRASIL-MONTES CLAROS' },
  { label: 'BRASIL-MOSSORÓ-DIX-SEPT ROSADO' },
  { label: 'BRASIL-MUCURI' },
  { label: 'BRASIL-NAVEGANTES' },
  { label: 'BRASIL-NOVO ARIPUANÃ-NOVO ARIPUANÃ' },
  { label: 'BRASIL-ÓBIDOS-TIRIÓS' },
  { label: 'BRASIL-OIAPOQUE-OIAPOQUE' },
  { label: 'BRASIL-ORIXIMINÁ-ORIXIMINÁ' },
  { label: 'BRASIL-OURILÂNDIA DO NORTE-OURILÂNDIA' },
  { label: 'BRASIL-PARANAGUÁ-PARANAGUÁ' },
  { label: 'BRASIL-PARANAÍBA-PARANAÍBA' },
  { label: 'BRASIL-PARANAVAÍ-PARANAVAÍ' },
  { label: 'BRASIL-PARINTINS-PARINTINS' },
  { label: 'BRASIL-PARNAIBA' },
  { label: 'BRASIL-PASSO FUNDO' },
  { label: 'BRASIL-PASSOS-MUNICIPAL JOSÉ FIGUEIRE' },
  { label: 'BRASIL-PATO BRANCO-PATO BRANCO' },
  { label: 'BRASIL-PATOS DE MINAS-PATOS DE MINAS' },
  { label: 'BRASIL-PAULO AFONSO-PAULO AFONSO' },
  { label: 'BRASIL-PELOTAS' },
  { label: 'BRASIL-PETROLINA' },
  { label: 'BRASIL-PICOS-PICOS' },
  { label: 'BRASIL-PIMENTA BUENO-PIMENTA BUENO' },
  { label: 'BRASIL-PINHEIRO-PINHEIRO' },
  { label: 'BRASIL-PIRACICABA-PIRACICABA' },
  { label: 'BRASIL-PIRAPORA-PIRAPORA' },
  { label: 'BRASIL-PITINGA-PITINGA' },
  { label: 'BRASIL-POÇOS DE CALDAS-POÇOS DE CALDA' },
  { label: 'BRASIL-PONTA GROSSA-PONTA GROSSA - CO' },
  { label: 'BRASIL-PONTA PORA' },
  { label: 'BRASIL-PONTES E LACERDA-PONTES E LACE' },
  { label: 'BRASIL-PORTO ALEGRE' },
  { label: 'BRASIL-PORTO SEGURO' },
  { label: 'BRASIL-POUSO ALEGRE-POUSO ALEGRE' },
  { label: 'BRASIL-PRADO-PRADO' },
  { label: 'BRASIL-PRESIDENTE DUTRA-PRESIDENTE JO' },
  { label: 'BRASIL-PRESIDENTE PRUDENTE' },
  { label: 'BRASIL-RECIFE-INTERNATIONAL RECIFE' },
  { label: 'BRASIL-REDENÇÃO-REDENÇÃO' },
  { label: 'BRASIL-RIBEIRAO PRETO' },
  { label: 'BRASIL-RIO CLARO-RIO CLARO' },
  { label: 'BRASIL-RIO DE JANEIRO-SANTA CRUZ' },
  { label: 'BRASIL-RIO GRANDE' },
  { label: 'CANADÁ-CORNER BAY-CORNER BAY' },
  { label: 'CANADÁ-FORTALEZA-ALERTA' },
  { label: 'CHILE-ALTO PALENA-ALTO PALENA' },
  { label: 'CHILE-ANCUD-PUPELDE' },
  { label: 'CHILE-ANTOFAGASTA' },
  { label: 'CHILE-ARICA' },
  { label: 'CHILE-BALMACEDA' },
  { label: 'CHILE-CALAMA' },
  { label: 'CHILE-CASTRO-GAMBOA' },
  { label: 'CHILE-CERRO SOMBRERO-FRANCO BIANCO' },
  { label: 'CHILE-CHAITEN-CHAITÉN' },
  { label: 'CHILE-CHAÑARAL-CHAÑARAL' },
  { label: 'CHILE-CHILE CHICO-CHILE CHICO' },
  { label: 'CHILE-CHILLAN' },
  { label: 'CHILE-COCHRANE-COCHRANE' },
  { label: 'CHILE-CONCEPCION' },
  { label: 'CHILE-COPIAPO' },
  { label: 'CHILE-COQUIMBO-TAMBILLOS' },
  { label: 'CHILE-COYHAIQUE-TENIENTE VIDAL' },
  { label: 'CHILE-DALCAHUE-MOCOPULLI' },
  { label: 'CHILE-EL SALVADOR' },
  { label: 'CHILE-FRUTILLAR-EL AVELLANO' },
  { label: 'CHILE-FUTALEUFU-FUTALEUFÚ' },
  { label: 'CHILE-IQUIQUE' },
  { label: 'CHILE-ISLA DE PASCUA-MATAVERI' },
  { label: 'CHILE-LA SERENA' },
  { label: 'CHILE-LINARES-MUNICIPAL DE LINARES' },
  { label: 'CHILE-LOS ANDES-SAN RAFAEL' },
  { label: 'CHILE-LOS ANGELES-MARÍA DOLORES' },
  { label: 'CHILE-OSORNO-CAÑAL BAJO CARLOS - HOT' },
  { label: 'CHILE-OVALLE-EL TUQUI' },
  { label: 'CHILE-PORVENIR-CAPITAN FUENTES MARTI' },
  { label: 'CHILE-PUCON-PUCÓN' },
  { label: 'CHILE-PUERTO AYSEN-CABO 1° JUAN ROMÁ' },
  { label: 'CHILE-PUERTO MONTT' },
  { label: 'CHILE-PUERTO NATALES-TTE. JULIO GALL' },
  { label: 'CHILE-PUERTO VARAS-EL MIRADOR' },
  { label: 'CHILE-PUNTA ARENAS' },
  { label: 'CHILE-RANCAGUA-DE LA INDEPENDENCIA' },
  { label: 'CHILE-SAN FELIPE-VÍCTOR LAFÓN' },
  { label: 'CHILE-SANTIAGO-COMMODORE ARTURO MERI' },
  { label: 'CHILE-TALCA-PANGUILEMO' },
  { label: 'CHILE-TALTAL-LAS BREAS' },
  { label: 'CHILE-TEMUCO' },
  { label: 'CHILE-TOCOPILLA-BARRILES' },
  { label: 'CHILE-VALDIVIA' },
  { label: 'CHILE-VALLENAR-VALLENAR' },
  { label: 'CHILE-VICTORIA-VICTORIA' },
  { label: 'CHILE-VIÑA DEL MAR-RODELILLO' },
  { label: 'CHILE-VIÑA DEL MAR-VIÑA DEL MAR' },
  { label: 'CHINA-ABA-HONGYUAN' },
  { label: 'CHINA-AKSU' },
  { label: 'CHINA-ANQING' },
  { label: 'CHINA-ANKANG' },
  { label: 'CHINA-ANSHUN-ANSHUN HUANGGUOSHU' },
  { label: 'CHINA-ANYANG-ANYANG' },
  { label: 'CHINA-ARXAN-ARXAN YI ERSHI' },
  { label: 'CHINA-BAICHENG-CHANG AN' },
  { label: 'CHINA-BAISE-BAISE YOUJIANG' },
  { label: 'CHINA-BAISHAN-CHANGBAISHAN' },
  { label: 'CHINA-BANGDA' },
  { label: 'CHINA-BAOSHAN' },
  { label: 'CHINA-BAOTOU' },
  { label: 'CHINA-BAYANNUR-BAYANNUR TIANJITAI' },
  { label: 'CHINA-BEIHAI' },
  { label: 'CHINA-BEIJING-NANYUAN' },
  { label: 'CHINA-BENGBU-BENGBU' },
  { label: 'CHINA-BIJIE-BIJIE FEIXIONG' },
  { label: 'CHINA-BOLE-ALASHANKOU BOLE (BORTALA)' },
  { label: 'CHINA-BURQIN-KANAS' },
  { label: 'CHINA-CHANGDE' },
  { label: 'CHINA-CHANGHAI-CHANGHAI' },
  { label: 'CHINA-CHANGSHA-CHANGSHA HUANGHUA INTL' },
  { label: 'CHINA-CHANGSHA-HUANGHUA INTERNATIONAL' },
  { label: 'CHINA-CHANGZHI-CHANGZHI' },
  { label: 'CHINA-CHANGZHOU' },
  { label: 'CHINA-CHIFENG' },
  { label: 'CHINA-CHIZHOU-JIUHUASHAN' },
  { label: 'CHINA-CIVIL AVIATION FLIGHT UNIVERSITY' },
  { label: 'CHINA-DALI CITY' },
  { label: 'CHINA-DANDONG-DANDONG' },
  { label: 'CHINA-DAQING SHI-SAERTU' },
  { label: 'CHINA-DATONG-DATONG' },
  { label: 'CHINA-DAXIAN' },
  { label: 'CHINA-DAYONG' },
  { label: 'CHINA-DONGYING-DONGYING SHENGLI' },
  { label: 'CHINA-DUNHUANG' },
  { label: 'CHINA-ENSHI' },
  { label: 'CHINA-ERENHOT-ERENHOT SAIWUSU INTERNATIONAL' },
  { label: 'CHINA-FOSHAN-FOSHAN SHADI' },
  { label: 'CHINA-FUYANG' },
  { label: 'CHINA-FUYUN-FUYUN KOKTOKAY' },
  { label: 'CHINA-FUZHOU' },
  { label: 'CHINA-GANZHOU-GANZHOU' },
  { label: 'CHINA-GOLMUD' },
  { label: 'CHINA-GOLOG-GOLOG MAQIN' },
  { label: 'CHINA-GUANGYUAN-GUANGYUAN' },
  { label: 'CHINA-GUIYANG' },
  { label: 'CHINA-GUYUAN-GUYUAN LIUPANSHAN' },
  { label: 'CHINA-HAIKOU' },
  { label: 'CHINA-HAILAR' },
  { label: 'CHINA-HAMI-HAMI' },
  { label: 'CHINA-HANDAN-HANDAN' },
  { label: 'CHINA-HANZHONG' },
  { label: 'CHINA-HECHI-HECHI JINCHENGJIANG' },
  { label: 'CHINA-HEFEI' },
  { label: 'CHINA-HEIHE-HEIHE' },
  { label: 'CHINA-HENGYANG-HENGYANG NANYUE' },
  { label: 'CHINA-HOHHOT' },
  { label: 'CHINA-HOTAN' },
  { label: 'CHINA-HUAI AN-LIANSHUI' },
  { label: 'CHINA-HUAIHUA-ZHIJIANG' },
  { label: 'CHINA-HUANGPING-KAILI' },
  { label: 'CHINA-HUANGYAN' },
  { label: 'CHINA-HUIZHOU-HUIZHOU' },
  { label: 'CHINA-JIAGEDAQI-JIAGEDAQI' },
  { label: 'CHINA-JINCHANG-JINCHUAN' },
  { label: 'CHINA-JIUQUAN-JIUHUANG' },
  { label: 'CHINA-JIUZHAIGOU-JIUZHAI HUANGLONG' },
  { label: 'CHINA-JIXI-JIXI XINGKAIHU' },
  { label: 'CHINA-JUZHA' },
  { label: 'CHINA-KARAMAY-KARAMAY' },
  { label: 'COLOMBIA-BARRANQUILLA' },
  { label: 'COLOMBIA-BOGOTÁ' },
  { label: 'COLOMBIA-BUCARAMANGA' },
  { label: 'COLOMBIA-BUENAVENTURA' },
  { label: 'COLOMBIA-CALI' },
  { label: 'COLOMBIA-CARTAGENA' },
  { label: 'COLOMBIA-CÚCUTA' },
  { label: 'COLOMBIA-MANIZALES' },
  { label: 'COLOMBIA-MEDELLÍN, RIONEGRO' },
  { label: 'COLOMBIA-NEIVA' },
  { label: 'COLOMBIA-PEREIRA' },
  { label: 'COLOMBIA-QUIBDÓ' },
  { label: 'COLOMBIA-RIOHACHA' },
  { label: 'COLOMBIA-SANTA MARTA' },
  { label: 'ECUADOR-AMBATO-CHACHOÁN' },
  { label: 'ECUADOR-BAHÍA DE CARAQUEZ-LOS PERALES' },
  { label: 'ECUADOR-COCA-FRANCISCO DE ORELLANA' },
  { label: 'ECUADOR-CUENCA' },
  { label: 'ECUADOR-ESMERALDAS' },
  { label: 'ECUADOR-GALAPAGOS' },
  { label: 'ECUADOR-GUAYAQUIL-JOSÉ JOAQUÍN DE OLME' },
  { label: 'ECUADOR-ISABELA-GENERAL VILLAMIL' },
  { label: 'ECUADOR-JIPIJAPA-JIPIJAPA' },
  { label: 'ECUADOR-LAGO AGRIO' },
  { label: 'ECUADOR-LATACUNGA-COTOPAXI INTERNATION' },
  { label: 'ECUADOR-LOJA' },
  { label: 'ECUADOR-MACARÁ-JOSE MARIA VELASCO IBAR' },
  { label: 'ECUADOR-MACAS' },
  { label: 'ECUADOR-MACHALA' },
  { label: 'ECUADOR-MANTA' },
  { label: 'ECUADOR-PORTOVIEJO' },
  { label: 'ECUADOR-PUERTO PUTUMAYO-PUTUMAYO' },
  { label: 'ECUADOR-QUITO-MARISCAL SUCRE INTERNATI' },
  { label: 'ECUADOR-SALINAS-GENERAL ULPIANO PAEZ' },
  { label: 'ECUADOR-SAN CRISTÓBAL-SAN CRISTÓBAL' },
  { label: 'ECUADOR-SANTA ROSA-SANTA ROSA INTERNAT' },
  { label: 'ECUADOR-SANTIAGO DE MÉNDEZ-MÉNDEZ' },
  { label: 'ECUADOR-SHELL MERA-RIO AMAZONAS' },
  { label: 'ECUADOR-SUCUA-SUCUA' },
  { label: 'ECUADOR-TAISHA-TAISHA' },
  { label: 'ECUADOR-TARAPOA-TARAPOA' },
  { label: 'ECUADOR-TENA-JUMANDY' },
  { label: 'ECUADOR-TIPUTINI-TIPUTINI' },
  { label: 'ECUADOR-TULCAN' },
  { label: 'EE.UU-ATLANTA' },
  { label: 'EE.UU-LOS ÁNGELES' },
  { label: 'EE.UU-CHICAGO O HARE' },
  { label: 'EE.UU-DALLAS/FORT WORTH' },
  { label: 'EE.UU-DENVER' },
  { label: 'EE.UU-NUEVA YORK - JFK' },
  { label: 'EE.UU-SAN FRANCISCO' },
  { label: 'EE.UU-SEATTLE-TACOMA' },
  { label: 'EE.UU-LAS VEGAS' },
  { label: 'EE.UU-ORLANDO' },
  { label: 'EE.UU-MIAMI' },
  { label: 'EE.UU-CHARLOTTE' },
  { label: 'EE.UU-PHOENIX' },
  { label: 'EE.UU-HOUSTON - INTERCONTINENTAL' },
  { label: 'EE.UU-BOSTON' },
  { label: 'EE.UU-NEWARK' },
  { label: 'EE.UU-MINNEAPOLIS/ST. PAUL' },
  { label: 'EE.UU-DETROIT' },
  { label: 'EE.UU-FILADELFIA' },
  { label: 'EE.UU-NUEVA YORK - LAGUARDIA' },
  { label: 'EE.UU-BALTIMORE' },
  { label: 'EE.UU-FORT LAUDERDALE' },
  { label: 'EE.UU-SALT LAKE CITY' },
  { label: 'EE.UU-SAN DIEGO' },
  { label: 'EE.UU-WASHINGTON - NATIONAL' },
  { label: 'EE.UU-HONOLULU' },
  { label: 'EE.UU-TAMPA' },
  { label: 'EE.UU-PORTLAND' },
  { label: 'EE.UU-SAN LUIS' },
  { label: 'EE.UU-NASHVILLE' },
  { label: 'EE.UU-AUSTIN' },
  { label: 'EE.UU-NUEVA ORLEANS' },
  { label: 'EE.UU-RALEIGH/DURHAM' },
  { label: 'EE.UU-OAKLAND' },
  { label: 'EE.UU-SACRAMENTO' },
  { label: 'EE.UU-KANSAS CITY' },
  { label: 'EE.UU-CLEVELAND' },
  { label: 'EE.UU-INDIANÁPOLIS' },
  { label: 'EE.UU-SAN ANTONIO' },
  { label: 'EE.UU-COLUMBUS' },
  { label: 'EE.UU-PITTSBURGH' },
  { label: 'EE.UU-MILWAUKEE' },
  { label: 'EE.UU-CINCINNATI' },
  { label: 'EE.UU-SANTA ANA (ORANGE COUNTY)' },
  { label: 'EE.UU-MEMPHIS' },
  { label: 'EE.UU-JACKSONVILLE' },
  { label: 'EE.UU-HARTFORD' },
  { label: 'EE.UU-BÚFALO' },
  { label: 'ESPAÑA-LA GOMERA' },
  { label: 'ESPAÑA-ALBACETE' },
  { label: 'ESPAÑA-BARCELONA-EL PRAT' },
  { label: 'ESPAÑA-BILBAO' },
  { label: 'ESPAÑA-BURGOS' },
  { label: 'ESPAÑA-CEUTA' },
  { label: 'ESPAÑA-REGIÓN DE MURCIA' },
  { label: 'ESPAÑA-A CORUÑA' },
  { label: 'ESPAÑA-GRAN CANARIA' },
  { label: 'ESPAÑA-LEÓN' },
  { label: 'ESPAÑA-LLEIDA-ALGUAIRE' },
  { label: 'ESPAÑA-LOGROÑO-AGONCILLO' },
  { label: 'ESPAÑA-MADRID-BARAJAS' },
  { label: 'ESPAÑA-MÁLAGA' },
  { label: 'ESPAÑA-MELILLA' },
  { label: 'ESPAÑA-PAMPLONA' },
  { label: 'ESPAÑA-SALAMANCA' },
  { label: 'ESPAÑA-SANTIAGO DE COMPOSTELA' },
  { label: 'ESPAÑA-SEVILLA' },
  { label: 'ESPAÑA-VALENCIA' },
  { label: 'ESPAÑA-VIGO' },
  { label: 'ESPAÑA-ALICANTE-ELCHE' },
  { label: 'ESPAÑA-ALMERÍA' },
  { label: 'ESPAÑA-ASTURIAS' },
  { label: 'ESPAÑA-BADAJOZ' },
  { label: 'ESPAÑA-FUERTEVENTURA' },
  { label: 'ESPAÑA-GIRONA-COSTA BRAVA' },
  { label: 'ESPAÑA-GRANADA' },
  { label: 'ESPAÑA-JEREZ DE LA FRONTERA' },
  { label: 'ESPAÑA-LANZAROTE' },
  { label: 'ESPAÑA-MENORCA' },
  { label: 'ESPAÑA-REUS' },
  { label: 'ESPAÑA-SAN SEBASTIÁN' },
  { label: 'ESPAÑA-LA PALMA' },
  { label: 'ESPAÑA-SANTANDER' },
  { label: 'ESPAÑA-VALLADOLID' },
  { label: 'ESPAÑA-EL HIERRO' },
  { label: 'ESPAÑA-VITORIA' },
  { label: 'ESPAÑA-ZARAGOZA' },
  { label: 'GUAM-SUMTER-SUMTER' },
  { label: 'GUATEMALA-SAN MIGUEL' },
  { label: 'HOLANDA-AMSTERDAM-AMSTERDAM SCHIPHOL' },
  { label: 'HONG KONG-HONG KONG-HONG KONG INTERNATIO' },
  { label: 'HONG KONG-HONG KONG-SHUN TAK' },
  { label: 'HONG KONG-KWUN TONG-KWUN TONG' },
  { label: 'IBIZA-SPAIN	IBIZA' },
  { label: 'INDIA-AGARTALA' },
  { label: 'INDIA-AGATTI-AGATTI' },
  { label: 'INDIA-AGRA' },
  { label: 'INDIA-AHMEDABAD' },
  { label: 'INDIA-AIZAWL' },
  { label: 'INDIA-AKOLA-AKOLA' },
  { label: 'INDIA-ALLAHABAD-ALLAHABAD' },
  { label: 'INDIA-ALONG-ALONG' },
  { label: 'INDIA-AMRITSAR' },
  { label: 'INDIA-AURANGABAD' },
  { label: 'INDIA-BAGDOGRA' },
  { label: 'INDIA-BALURGHAT-BALURGHAT' },
  { label: 'INDIA-BELGAUM-BELGAUM' },
  { label: 'INDIA-BELLARY-BELLARY' },
  { label: 'INDIA-BHAVNAGAR' },
  { label: 'INDIA-BHOPAL' },
  { label: 'INDIA-BHUBANESWAR' },
  { label: 'INDIA-BHUJ' },
  { label: 'INDIA-BIKANER-NAL' },
  { label: 'INDIA-BILASPUR-BILASPUR' },
  { label: 'INDIA-CHANDIGARH' },
  { label: 'INDIA-CHENNAI-CHENNAI INTERNATIONAL' },
  { label: 'INDIA-COCHIN' },
  { label: 'INDIA-COIMBATORE' },
  { label: 'INDIA-COOCH BEHAR-COOCH BEHAR' },
  { label: 'INDIA-CUDDAPAH-CUDDAPAH' },
  { label: 'INDIA-DAMAN-DAMAN' },
  { label: 'INDIA-DAPORIJO-DAPORIJO' },
  { label: 'INDIA-DARJEELING-DARJEELING' },
  { label: 'INDIA-DEHRADUN-DEHRADUN' },
  { label: 'INDIA-DHANBAD-DHANBAD' },
  { label: 'INDIA-DIBRUGARN' },
  { label: 'INDIA-DIMAPUR' },
  { label: 'INDIA-DIV' },
  { label: 'INDIA-DURGAPUR-KAZI NAZRUL ISLAM' },
  { label: 'INDIA-GAWAHATI' },
  { label: 'INDIA-GAYA-GAYA' },
  { label: 'INDIA-GOA' },
  { label: 'INDIA-GORAKHPUR-GORAKHPUR' },
  { label: 'INDIA-GUNA-GUNA' },
  { label: 'INDIA-GWALIOR' },
  { label: 'INDIA-HISSAR-HISSAR' },
  { label: 'INDIA-HUBLI-HUBLI' },
  { label: 'INDIA-HYDERABAD-BEGUMPET' },
  { label: 'INDIA-HYDERABAD-RAJIV GANDHI INTERNA' },
  { label: 'INDIA-IMPHAL' },
  { label: 'INDIA-INDORE' },
  { label: 'INDIA-JABALPUR-JABALPUR' },
  { label: 'INDIA-JAGDALPUR-JAGDALPUR' },
  { label: 'INDIA-JAIPUR' },
  { label: 'INDIA-JAISALMER-JAISALMER' },
  { label: 'INDIA-JAMNAGAR' },
  { label: 'INDIA-JAMSHEDPUR-JAMSHEDPUR' },
  { label: 'INDIA-JEYPORE-JEYPORE' },
  { label: 'INDIA-JODHPUR' },
  { label: 'INDIA-JOMMU' },
  { label: 'INDIA-JORHAT' },
  { label: 'INDIA-KAILASHAHAR-KAILASHAHAR' },
  { label: 'INDIA-KAMALPUR-KAMALPUR' },
  { label: 'INDIA-KANDLA-KANDLA' },
  { label: 'INDIA-KANGRA-KANGRA' },
  { label: 'INDIA-KANPUR-KANPUR' },
  { label: 'INDIA-KESHOD-KESHOD' },
  { label: 'INDIA-KHAJURAHO' },
  { label: 'INDIA-KHOWAI-KHOWAI' },
  { label: 'INDIA-KOLHAPUR-KOLHAPUR' },
  { label: 'INDIA-KOLKATA-NETAJI SUBHAS CHANDRA' },
  { label: 'INDIA-KOTA-KOTA' },
  { label: 'INDIA-KOZHIKODE' },
  { label: 'INDIA-KULLU MANALI-KULLU MANALI' },
  { label: 'INDIA-LATUR-MUROD KOND' },
  { label: 'INDIA-LEH' },
  { label: 'INDIA-LILABARI-NORTH LAKHIMPUR' },
  { label: 'INDIA-LUCKNOW' },
  { label: 'INDIA-LUDHIANA-LUDHIANA' },
  { label: 'INDIA-MADURAI' },
  { label: 'INDIA-MALDA-MALDA' },
  { label: 'INDIA-MANGALORE' },
  { label: 'INDIA-MOHANBARI-MOHANBARI' },
  { label: 'INDIA-MUMBAI-CHHATRAPATI SHIVAJI INT' },
  { label: 'INDIA-MUZAFFARNAGAR-MUZAFFARNAGAR' },
  { label: 'INDIA-MUZAFFARPUR-MUZAFFARPUR' },
  { label: 'INDIA-MYSORE-MYSORE' },
  { label: 'INDIA-NAGPUR' },
  { label: 'INDIA-NANDED-NANDED' },
  { label: 'INDIA-NEW DELHI-INDIRA GANDHI INTERN' },
  { label: 'INDIA-NEYVELI-NEYVELI' },
  { label: 'INDIA-OSMANABAD-OSMANABAD' },
  { label: 'INDIA-PANTNAGAR-PANTNAGAR' },
  { label: 'INDIA-PASIGHAT-PASIGHAT' },
  { label: 'INDIA-PATNA' },
  { label: 'INDIA-PONDICHERRY-PONDICHERRY' },
  { label: 'INDIA-PORBANDAR' },
  { label: 'INDIA-PORT BLAIR' },
  { label: 'INDIA-PUTTAPARTHI' },
  { label: 'INDIA-RAIPUR-RAIPUR' },
  { label: 'INDIA-RAJAHMUNDRY-RAJAHMUNDRY' },
  { label: 'INDIA-RAJKOT' },
  { label: 'INDIA-RAJOURI-RAJOURI' },
  { label: 'INDIA-RAMAGUNDAM-BASANTH NAGAR' },
  { label: 'INDIA-RANCHI' },
  { label: 'INDIA-RATNAGIRI-RATNAGIRI' },
  { label: 'INDIA-REWA-REWA, CHORHATA, REWA' },
  { label: 'INDIA-ROURKELA-ROURKELA' },
  { label: 'INDIA-RUPSI INDIA-RUPSI INDIA' },
  { label: 'INDIA-SALEM-SALEM' },
  { label: 'INDIA-SATNA-SATNA' },
  { label: 'INDIA-SHILLONG-SHILLONG' },
  { label: 'INDIA-SHIMLA-SHIMLA' },
  { label: 'INDIA-SILCHAR' },
  { label: 'INDIA-SOLAPUR-SOLAPUR' },
  { label: 'INDIA-SRINAGAR' },
  { label: 'INDIA-SURAT-SURAT' },
  { label: 'INDIA-TEZPUR' },
  { label: 'INDIA-TEZU-TEZU' },
  { label: 'INDIA-THIRUVANANTHAPURAM' },
  { label: 'INDIA-THOOTHUKUDI-TUTICORIN' },
  { label: 'INDIA-TIRUCHIRAPALLY' },
  { label: 'INDIA-TIRUPATI' },
  { label: 'INDIA-VADODARA' },
  { label: 'INDIA-VARANASI' },
  { label: 'INDIA-VIJAYANAGAR-VIJAYANAGAR AERODR' },
  { label: 'INDIA-VIJAYAWADA-VIJAYAWADA' },
  { label: 'INDIA-VISHAKHAPATNAM' },
  { label: 'INDIA-WARRANGAL-WARANGAL' },
  { label: 'INDIA-ZERO-ZERO' },
  { label: 'INDIA-MAHARASHTRA	PUNE' },
  { label: 'INDONESIA-TIAKUR-JOS ORNO IMSULA' },
  { label: 'ISRAEL-ELAT' },
  { label: 'ITALIA-ALBENGA (SV)-VILLANOVA DALBENGA' },
  { label: 'ITALIA-AOSTA' },
  { label: 'ITALIA-BOLOGNA-BOLOGNA GUGLIELMO MARCONI' },
  { label: 'ITALIA-BOLZANO' },
  { label: 'ITALIA-COMISO' },
  { label: 'ITALIA-CROTONE' },
  { label: 'ITALIA-CUNEO-CUNEO INTERNATIONAL' },
  { label: 'ITALIA-FOGGIA' },
  { label: 'ITALIA-FORLÌ (FC)-FORLÌ' },
  { label: 'ITALIA-GÉNOVA' },
  { label: 'ITALIA-LAMEZIA TERME' },
  { label: 'ITALIA-MILÁN-PARMA' },
  { label: 'ITALIA-NÁPOLES-NÁPOLES INTERNACIONAL' },
  { label: 'ITALIA-PALERMO-FALCONE–BORSELLINO' },
  { label: 'ITALIA-REGGIO CALABRIA' },
  { label: 'ITALIA-SALERNO-SALERNO COSTA DAMALFI' },
  { label: 'ITALIA-TARANTO' },
  { label: 'ITALIA-TURÍN' },
  { label: 'ITALIA-VENECIA-VENECIA MARCO POLO' },
  { label: 'ITALIA-ALGHERO' },
  { label: 'ITALIA-ANCONA' },
  { label: 'ITALIA-BARI' },
  { label: 'ITALIA-BRINDISI' },
  { label: 'ITALIA-CAGLIARI' },
  { label: 'ITALIA-CATANIA' },
  { label: 'ITALIA-ISLA DE ELBA' },
  { label: 'ITALIA-FLORENCIA-PERETOLA' },
  { label: 'ITALIA-LAMPEDUSA' },
  { label: 'ITALIA-MILÁN-MALPENSA' },
  { label: 'ITALIA-MILÁN-LINATE' },
  { label: 'ITALIA-MILÁN-ORIO AL SERIO' },
  { label: 'ITALIA-MONTICHIARI (BS)-BRESCIA' },
  { label: 'ITALIA-OLBIA' },
  { label: 'ITALIA-PANTELLERIA' },
  { label: 'ITALIA-PERUGIA' },
  { label: 'ITALIA-PESCARA' },
  { label: 'ITALIA-PISA-PISA INTERNACIONAL GALILEO GALILEI' },
  { label: 'ITALIA-RÍMINI' },
  { label: 'ITALIA-ROMA-CIAMPINO' },
  { label: 'ITALIA-ROMA-LEONARDO DA VINCI INTERNACIONAL' },
  { label: 'ITALIA-TRAPANI' },
  { label: 'ITALIA-TRIESTE' },
  { label: 'ITALIA-VENECIA-TREVISO' },
  { label: 'ITALIA-VERONA' },
  { label: 'JAPÓN-SAPPORO-OKADAMA' },
  { label: 'JAPÓN-AKITA' },
  { label: 'JAPÓN-AMAMI O SHIMA' },
  { label: 'JAPÓN-AOMORI' },
  { label: 'JAPÓN-FUKUSHIMA' },
  { label: 'JAPÓN-HACHIJO JIMA' },
  { label: 'JAPÓN-HAKODATE' },
  { label: 'JAPÓN-HIROSHIMA-INTERNATIONAL' },
  { label: 'JAPÓN-ISHIGAKIJ' },
  { label: 'JAPÓN-KAGOSHIMA-KAGOSHIMA' },
  { label: 'JAPÓN-KANAZAWA-KOMATSU' },
  { label: 'JAPÓN-KOBE-KOBE' },
  { label: 'JAPÓN-KOCHI' },
  { label: 'JAPÓN-KUMAMOTO-KUMAMOTO' },
  { label: 'JAPÓN-KUSHIRO' },
  { label: 'JAPÓN-MATSUMOTO' },
  { label: 'JAPÓN-MATSUYAMA' },
  { label: 'JAPÓN-MIYAKO JIMA' },
  { label: 'JAPÓN-MIYAZAKI-MIYAZAKI' },
  { label: 'JAPÓN-NAGASAKI' },
  { label: 'JAPÓN-NIIGATA-NIIGATA' },
  { label: 'JAPÓN-OITA' },
  { label: 'JAPÓN-OKAYAMA' },
  { label: 'JAPÓN-OSAKA-ITAMI' },
  { label: 'JAPÓN-OSAKA-OSAKA INTERNATIONAL' },
  { label: 'JAPÓN-SAPPORO-CHITOSE' },
  { label: 'JAPÓN-SENDAI-SENDAI' },
  { label: 'JAPÓN-TAKAMATSU-TAKAMATSU' },
  { label: 'JAPÓN-TOKUSHIMA' },
  { label: 'JAPÓN-TOKYO-HANEDA' },
  { label: 'JAPÓN-TOKYO-NARITA' },
  { label: 'JAPÓN-TOYAMA' },
  { label: 'JAPÓN-UBE' },
  { label: 'JAPÓN-YAMAGATA' },
  { label: 'JAPÓN-FUKUOKA' },
  { label: 'JAPÓN-NAGOYA' },
  { label: 'JAPÓN-OKINAWA' },
  { label: 'JAPÓN-AGUNI' },
  { label: 'JAPÓN-ASAHIKAWA' },
  { label: 'JAPÓN-FUKUE' },
  { label: 'JAPÓN-FUKUI-FUKUI' },
  { label: 'JAPÓN-HATERUMA' },
  { label: 'JAPÓN-IE-IE JIMA' },
  { label: 'JAPÓN-IKI-IKI' },
  { label: 'JAPÓN-IWAMI' },
  { label: 'JAPÓN-IZUMO' },
  { label: 'JAPÓN-KIKAI-KIKAI' },
  { label: 'JAPÓN-KITADAITO' },
  { label: 'JAPÓN-KITAKYŪSHŪ-KITAKYŪSHŪ' },
  { label: 'JAPÓN-KUMEJIMA' },
  { label: 'JAPÓN-MAKINOHARA / SHIMADA-MT. FUJI' },
  { label: 'JAPÓN-MEMANBETSU' },
  { label: 'JAPÓN-MINAMI DAITO' },
  { label: 'JAPÓN-MISAWA' },
  { label: 'JAPÓN-MIYAKEJIMA' },
  { label: 'JAPÓN-MONBETSU' },
  { label: 'JAPÓN-NAGOYA-NAGOYA' },
  { label: 'JAPÓN-NAKASHIBETSU-NAKASHIBETSU' },
  { label: 'JAPÓN-NIIHAMA-NIIHAMA' },
  { label: 'JAPÓN-OBIHIRO' },
  { label: 'JAPÓN-ODATE-ODATE NOSHIRO' },
  { label: 'JAPÓN-OKINOSHIMA-OKI' },
  { label: 'JAPÓN-OKOSHIRI' },
  { label: 'JAPÓN-OSHIMA' },
  { label: 'JAPÓN-RISHIRI' },
  { label: 'JAPÓN-SAGA-SAGA' },
  { label: 'JAPÓN-SHIMOJISHIMA-SHIMOJISHIMA' },
  { label: 'JAPÓN-SHIRAHAMA-NANKI SHIRAHAMA' },
  { label: 'JAPÓN-SHONAI' },
  { label: 'JAPÓN-TANEGASHIMA-NEW TANEGASHIMA' },
  { label: 'JAPÓN-TOKUNOSHIMA' },
  { label: 'JAPÓN-TOTTORI' },
  { label: 'JAPÓN-TSUSHIMA' },
  { label: 'JAPÓN-WAJIMA-NOTO' },
  { label: 'JAPÓN-WAKKANAI' },
  { label: 'JAPÓN-YAKUSHIMA-YAKUSHIMA' },
  { label: 'JAPÓN-YONAGO' },
  { label: 'MALASIA-JULIACA' },
  { label: 'MALASIA-SPRATLEY ISLANDS-LAYANG-LAYANG' },
  { label: 'MEXICO-ACAPULCO' },
  { label: 'MEXICO-AGUASCALIENTES' },
  { label: 'MEXICO-ATIZAPAN DE ZARAGOZA-ATIZAPAN' },
  { label: 'MEXICO-CABO SAN LUCAS-LOS CABOS' },
  { label: 'MEXICO-CANCUN-CANCÚN INTERNATIONAL' },
  { label: 'MEXICO-CHICHEN ITZA-CHICHEN ITZA INTE' },
  { label: 'MEXICO-CHIHUAHUA' },
  { label: 'MEXICO-CIUDAD DEL CARMEN' },
  { label: 'MEXICO-CIUDAD JUAREZ' },
  { label: 'MEXICO-CIUDAD OBREGON' },
  { label: 'MEXICO-CIUDAD VICTORIA' },
  { label: 'MEXICO-COLIMA' },
  { label: 'MEXICO-COZUMEL' },
  { label: 'MEXICO-CULIACAN' },
  { label: 'MEXICO-GENERAL ESCOBEDO-DEL NORTE INT' },
  { label: 'MEXICO-GUADALAJARA' },
  { label: 'MEXICO-GUANAJUATO' },
  { label: 'MEXICO-HERMOSILLO' },
  { label: 'MEXICO-HUATULCO' },
  { label: 'MEXICO-JALAPA' },
  { label: 'MEXICO-LA PAZ' },
  { label: 'MEXICO-LORETO' },
  { label: 'MEXICO-LOS MOCHIS' },
  { label: 'MEXICO-LOZARO CARDENAS' },
  { label: 'MEXICO-MANZANILLO' },
  { label: 'MEXICO-MAZATLAN' },
  { label: 'MEXICO-MERIDA' },
  { label: 'MEXICO-MEXICALI' },
  { label: 'MEXICO-MEXICO CITY-AEROPUERTO INTERNA' },
  { label: 'MEXICO-MINATITLA' },
  { label: 'MEXICO-MONTERREY' },
  { label: 'MEXICO-MORELIA' },
  { label: 'MEXICO-NUEVO LAREDO' },
  { label: 'MEXICO-OAXACA' },
  { label: 'MEXICO-PUEBLA' },
  { label: 'MEXICO-PUERTO ESCONDIDO' },
  { label: 'MEXICO-PUERTO VALLARTA' },
  { label: 'MEXICO-SAN LUIS POTOSI' },
  { label: 'MEXICO-SANTA ROSALIA-PALO VERDE' },
  { label: 'MEXICO-TAMPICO' },
  { label: 'MEXICO-TIJUANA-GENERAL ABELARDO L. RO' },
  { label: 'MEXICO-TUXTLA GUTIERREZ' },
  { label: 'MEXICO-URUAPAN' },
  { label: 'MEXICO-VERACRUZ' },
  { label: 'MEXICO-VILLAHERMOSA' },
  { label: 'MEXICO-ZACATECAS-GENERAL LEOBARDO C.' },
  { label: 'MEXICO-ZIHUATANEJO/IXTAPA' },
  { label: 'MÉXICO-ABREOJOS-ABREOJOS' },
  { label: 'MÉXICO-ÁLAMOS-ÁLAMOS' },
  { label: 'MÉXICO-APATZINGÁN-PABLO L. SIDAR' },
  { label: 'MÉXICO-BAHÍA DE LOS ÁNGELES-BAHÍA DE' },
  { label: 'MÉXICO-CAMPECHE' },
  { label: 'MÉXICO-CANANEA-CANANEA' },
  { label: 'MÉXICO-CELAYA-CAPTAIN ROGELIO CASTILL' },
  { label: 'MÉXICO-CHETUMAL' },
  { label: 'MÉXICO-CIUDAD ACUÑA-CIUDAD ACUÑA NEW' },
  { label: 'MÉXICO-CIUDAD CONSTITUCIÓN-CIUDAD CON' },
  { label: 'MÉXICO-CIUDAD MANTE-CIUDAD MANTE NATI' },
  { label: 'MÉXICO-COMITAN-COMITAN' },
  { label: 'MÉXICO-CUERNAVACA' },
  { label: 'MÉXICO-DURANGO' },
  { label: 'MÉXICO-ENSENADA-ENSENADA' },
  { label: 'MÉXICO-GUAYMAS' },
  { label: 'MÉXICO-GUERRERO NEGRO' },
  { label: 'MÉXICO-ISLA MUJERES-ISLA MUJERES' },
  { label: 'MÉXICO-IXTEPEC' },
  { label: 'MÉXICO-LA RIBERA-PUNTA COLORADA' },
  { label: 'MÉXICO-LAGOS DE MORENO-FRANCISCO PRIM' },
  { label: 'MÉXICO-MATAMOROS' },
  { label: 'MÉXICO-MEXICALI-SAN FELIPE INTERNATIO' },
  { label: 'MÉXICO-MONCLOVA' },
  { label: 'MÉXICO-MULEGE-MULEGE' },
  { label: 'MÉXICO-NAVOJOA-NAVOJOA' },
  { label: 'MÉXICO-NOGALES-NOGALES INTERNATIONAL' },
  { label: 'MÉXICO-NUEVO CASAS GRANDES-NUEVO CASA' },
  { label: 'MÉXICO-PALENQUE' },
  { label: 'MÉXICO-PIEDRAS NEGRAS' },
  { label: 'MÉXICO-POCHUTLA-POCHUTLA' },
  { label: 'MÉXICO-POZA RICO' },
  { label: 'MÉXICO-PUERTO JUAREZ-PUERTO JUAREZ' },
  { label: 'MÉXICO-PUNTA CHIVATO-PUNTA CHIVATO' },
  { label: 'MÉXICO-QUERETARO' },
  { label: 'MÉXICO-REYNOSSA' },
  { label: 'MÉXICO-S. CRISTOBAL DEL CASAS' },
  { label: 'MÉXICO-SALINA CRUZ-SALINA CRUZ NAVAL' },
  { label: 'MÉXICO-SALTILLO' },
  { label: 'MÉXICO-SAN IGNACIO-SAN IGNACIO' },
  { label: 'MÉXICO-SAN LUIS RÍO COLORADO-SAN LUIS' },
  { label: 'MÉXICO-SOLIDARIDAD-PLAYA DEL CARMEN' },
  { label: 'MÉXICO-TAMUIN-TAMUIN' },
  { label: 'MÉXICO-TAPACHULA' },
  { label: 'MÉXICO-TEHUACAN-TEHUACAN' },
  { label: 'MÉXICO-TEPIC' },
  { label: 'MÉXICO-TIZIMIN-CUPUL' },
  { label: 'MÉXICO-TOLUCO' },
  { label: 'MÉXICO-TORREON' },
  { label: 'MÉXICO-TULUM-TULUM NAVAL AIR STATION' },
  { label: 'MÉXICO-ZAMORA-ZAMORA' },
  { label: 'MÉXICO-ZAPOTILTIC-ZAPOTILTIC - TUXPAN' },
  { label: 'NETHERLANDS-EINDHOVEN' },
  { label: 'NETHERLANDS-GRONINGEN' },
  { label: 'NETHERLANDS-LELYSTAD-LELYSTAD' },
  { label: 'NETHERLANDS-MAASTRICHT' },
  { label: 'NETHERLANDS-ROTTERDAM-ROTTERDAM THE HAGUE' },
  { label: 'PAÍSES BAJOS-ANTWERP' },
  { label: 'PAÍSES BAJOS-DEN HELDER-DE KOOY' },
  { label: 'PAÍSES BAJOS-ENSCHEDE-TWENTE AIRFIELD' },
  { label: 'PAKISTAN-BAHAWALPUR' },
  { label: 'PAKISTAN-BANNU' },
  { label: 'PAKISTAN-CHITRAL' },
  { label: 'PAKISTAN-DERA ISMAIL KHAN' },
  { label: 'PAKISTAN-FAISALABAD' },
  { label: 'PAKISTAN-GILGIT' },
  { label: 'PAKISTAN-GWADAR' },
  { label: 'PAKISTAN-HYDERABAD-HYDERABAD' },
  { label: 'PAKISTAN-ISLAMABAD-BENAZIR BHUTTO' },
  { label: 'PAKISTAN-JACOBABAD' },
  { label: 'PAKISTAN-JIWANI' },
  { label: 'PAKISTAN-KARACHI-JINNAH INTERNATIONAL' },
  { label: 'PAKISTAN-KHUZDAR' },
  { label: 'PAKISTAN-KOHAT-KOHAT' },
  { label: 'PAKISTAN-LAHORE-ALLAMA IQBAL INTERNATIO' },
  { label: 'PAKISTAN-MIRPUR KHAS-SUKKUR' },
  { label: 'PAKISTAN-MULTAN' },
  { label: 'PAKISTAN-MUZAFFARABAD' },
  { label: 'PAKISTAN-NAWABSHAH' },
  { label: 'PAKISTAN-PANJGER' },
  { label: 'PAKISTAN-PASNI' },
  { label: 'PAKISTAN-PESHAWAR' },
  { label: 'PAKISTAN-QUETTA' },
  { label: 'PAKISTAN-RAHIM YAR KHAN-SHAIKH ZAID' },
  { label: 'PAKISTAN-RAWALA KOT' },
  { label: 'PAKISTAN-SAIDU SHARIF-SAIDU SHARIF' },
  { label: 'PAKISTAN-SKARDU-SKARDU' },
  { label: 'PAKISTAN-SUI' },
  { label: 'PAKISTAN-TURBAT' },
  { label: 'PAKISTAN-ZHOB' },
  { label: 'PAKISTÁN-ABBOTTABAD-ABBOTTABAD' },
  { label: 'PAKISTÁN-BADIN-TALHAR' },
  { label: 'PAKISTÁN-BAHAWALNAGAR-BAHAWALNAGAR' },
  { label: 'PAKISTÁN-BHAGATANWALA-BHAGATANWALA' },
  { label: 'PAKISTÁN-CAMPBELLPORE-CAMPBELLPORE' },
  { label: 'PAKISTÁN-CHAGAI-REKO DIQ' },
  { label: 'PAKISTÁN-CHILAS-CHILAS' },
  { label: 'PAKISTÁN-DADU-DADU WEST' },
  { label: 'PAKISTÁN-DALBANDIN-DALBANDIN' },
  { label: 'PAKISTÁN-DERA GHAZI' },
  { label: 'PAKISTÁN-GUJRAT-GUJRAT' },
  { label: 'PAKISTÁN-KADANWARI' },
  { label: 'PAKISTÁN-KALAT-KALAT' },
  { label: 'PAKISTÁN-LORALAI-LORALAI' },
  { label: 'PAKISTÁN-MANGLA-MANGLA' },
  { label: 'PAKISTÁN-MANSEHRA-MANSEHRA' },
  { label: 'PAKISTÁN-NUSHKI-NUSHKI' },
  { label: 'PAKISTÁN-ORMARA' },
  { label: 'PAKISTÁN-SAHIWAL-SAHIWAL' },
  { label: 'PAKISTÁN-SEHWAN SHARIF-SEHWAN SHARIF' },
  { label: 'PAKISTÁN-SIALKOT-SIALKOT' },
  { label: 'PAKISTÁN-SIBI-SIBI' },
  { label: 'PAKISTÁN-TAFTAN-TAFTAN' },
  { label: 'PAKISTÁN-TARBELA-TARBELA DAM' },
  { label: 'PAKISTÁN-WAANA-WANA' },
  { label: 'PAKISTÁN-ZAMZAMA GAS FIELD-ZAMZAMA' },
  { label: 'PANAMA-JAQUE' },
  { label: 'PANAMA-PANAMA CITY-NORTHWEST FLORIDA' },
  { label: 'PANAMÁ-ACHUTUPO-ACHUTUPO' },
  { label: 'PANAMÁ-ALLIGANDI-ALLIGANDI' },
  { label: 'PANAMÁ-BAHIA PINAS' },
  { label: 'PANAMÁ-BOCA DE SÁBALO-SAMBU' },
  { label: 'PANAMÁ-BOCAS DEL TORO' },
  { label: 'PANAMÁ-CALEDONIA-CALEDONIA' },
  { label: 'PANAMÁ-CARTI-CARTI' },
  { label: 'PANAMÁ-CHANGUINDA' },
  { label: 'PANAMÁ-CHITRE' },
  { label: 'PANAMÁ-COLON' },
  { label: 'PANAMÁ-CONTADORA' },
  { label: 'PANAMÁ-CORAZÓN DE JESÚS AND NARGANÁ I' },
  { label: 'PANAMÁ-DAVID' },
  { label: 'PANAMÁ-EL PORVENIR-EL PORVENIR' },
  { label: 'PANAMÁ-EL REAL' },
  { label: 'PANAMÁ-FORT KOBBE-HOWARD AFB' },
  { label: 'PANAMÁ-GARACHINE' },
  { label: 'PANAMÁ-ISLA TUPILE-TUPILE' },
  { label: 'PANAMÁ-LA PALMA' },
  { label: 'PANAMÁ-MAMITUPO-MAMITUPO' },
  { label: 'PANAMÁ-MULATUPO-MULATUPO' },
  { label: 'PANAMÁ-NARGANA-NARGANA' },
  { label: 'PANAMÁ-PANAMA CITY-PAITILLA' },
  { label: 'PANAMÁ-PANAMÁ CITY-PANAMA PACIFIC INT' },
  { label: 'PANAMÁ-PLAYÓN CHICO-PLAYÓN CHICO' },
  { label: 'PANAMÁ-PUERTO OBALDIA-PUERTO OBALDIA' },
  { label: 'PANAMÁ-RÍO HATO-SCARLETT MARTINEZ INT' },
  { label: 'PANAMÁ-RIO SIDRA-RIO SIDRA' },
  { label: 'PANAMÁ-SANTA FE-SANTA FE' },
  { label: 'PANAMÁ-SANTIAGO-RUBEN CANTU' },
  { label: 'PANAMÁ-TICANTIQUI-TICANTIKI' },
  { label: 'PANAMÁ-TUBALA-TUBALA' },
  { label: 'PANAMÁ-USTUPO-USTUPO' },
  { label: 'PANAMÁ-WANNUKANDI-SAN BLAS' },
  { label: 'PANAMÁ-YAVIZA-YAVIZA' },
  { label: 'PAPÚA NUEVA GUINEA-RONDON-RONDON' },
  { label: 'PERU-AREQUIPA' },
  { label: 'PERU-AYACUCHO-CORONEL FAP ALFREDO M' },
  { label: 'PERU-CHICAYO' },
  { label: 'PERU-CUZCO' },
  { label: 'PERU-IQUITOS' },
  { label: 'PERU-JAUJA-FRANCISCO CARLE' },
  { label: 'PERU-JUANJUÍ-JUANJUI' },
  { label: 'PERU-LIMA-JORGE CHÁVEZ INTERNATIONA' },
  { label: 'PERU-PIURA' },
  { label: 'PERU-PUCALLPA' },
  { label: 'PERU-PUERTO MALDONADO' },
  { label: 'PERU-TACNA' },
  { label: 'PERU-TRUJILLO' },
  { label: 'PERÚ-ANDAHUAYLAS-ANDAHUAYLAS' },
  { label: 'PERÚ-ANDOAS-ALFEREZ FAP ALFREDO VLA' },
  { label: 'PERÚ-ANTA-COMANDANTE FAP GERMAN ARI' },
  { label: 'PERÚ-ATALAYA-TENIENTE GENERAL GERAR' },
  { label: 'PERÚ-BELLAVISTA-HUALLAGA' },
  { label: 'PERÚ-CAJAMARCA' },
  { label: 'PERÚ-CHACHAPOYAS-CHACHAPOYAS' },
  { label: 'PERÚ-CORRIENTES-TROMPETEROS' },
  { label: 'PERÚ-IBERIA-IBERIA' },
  { label: 'PERÚ-ILO-ILO' },
  { label: 'PERÚ-JAÉN-SHUMBA' },
  { label: 'PERÚ-LAS MALVINAS-LAS MALVINAS/ECHA' },
  { label: 'PERÚ-LEON VELARDE-SHIRINGAYOC/HACIE' },
  { label: 'PERÚ-MACHU PICHU-MACHU PICHU' },
  { label: 'PERÚ-MIRAFLORES-MIRAFLORES' },
  { label: 'PERÚ-MOYOBAMBA-MOYOBAMBA' },
  { label: 'PERÚ-PISCO-CAPITÁN FAP RENÁN ELÍAS' },
  { label: 'PERÚ-PLAZA SAPOSOA-SAPOSOA' },
  { label: 'PERÚ-RIO TIGRE-RIO TIGRE' },
  { label: 'PERÚ-RIOJA-JUAN SIMONS VELA' },
  { label: 'PERÚ-RODRIGUEZ DE MENDOZA-SAN NICOL' },
  { label: 'PERÚ-SAN FRANCISCO DE YESO-SAN FRAN' },
  { label: 'PERÚ-SAN JUAN APOSENTO-SAN JUAN APO' },
  { label: 'PERÚ-SAN JUAN DE MARCONA-SAN JUAN D' },
  { label: 'PERÚ-SANTA MARÍA-SANTA MARIA' },
  { label: 'PERÚ-TALARA-CAPITAN MONTES' },
  { label: 'PERÚ-TARAPOTO' },
  { label: 'PERÚ-TINGO MARIA-TINGO MARIA' },
  { label: 'PERÚ-TUMBES' },
  { label: 'PERÚ-UCHIZA-UCHIZA' },
  { label: 'PERÚ-YURIMAGUAS-MOISES BENZAQUEN RE' },
  { label: 'PHILIPPINES-SINOP' },
  { label: 'POLANIA-GDANSK-GDAŃSK LECH WAŁĘSA' },
  { label: 'POLANIA-KRAKOW-JOHN PAUL II INTERNATIO' },
  { label: 'POLANIA-POZNAN' },
  { label: 'POLANIA-SZCZECIN' },
  { label: 'POLONIA-BIAŁA PODLASKA-BIAŁA PODLASKA' },
  { label: 'POLONIA-BIAŁYSTOK-BIAŁYSTOK-KRYWLANY' },
  { label: 'POLONIA-BYDGOSZCZ' },
  { label: 'POLONIA-CZECHOWICE-DZIEDZICE-BIELSKO-B' },
  { label: 'POLONIA-CZĘSTOCHOWA-CZĘSTOCHOWA-RUDNIK' },
  { label: 'POLONIA-GLIWICE-GLIWICE' },
  { label: 'POLONIA-KATOWICE' },
  { label: 'POLONIA-KOLOBRZEG' },
  { label: 'POLONIA-KOSZALIN' },
  { label: 'POLONIA-ŁÓDŹ-ŁÓDŹ WŁADYSŁAW REYMONT' },
  { label: 'POLONIA-LUBLIN-LUBLIN' },
  { label: 'POLONIA-LUBLIN-LUBLIN RADWIEC AIRFIELD' },
  { label: 'POLONIA-NOWY TARG-NOWY TARG' },
  { label: 'POLONIA-OPOLE-OPOLE-POLSKA NOWA WIEŚ' },
  { label: 'POLONIA-RZESZÓW-RZESZÓW-JASIONKA' },
  { label: 'POLONIA-WARSAW-MODLIN' },
  { label: 'POLONIA-WARSAW-WARSAW CHOPIN' },
  { label: 'POLONIA-WROCLAW' },
  { label: 'POLONIA-ZIELANA' },
  { label: 'REINO UNIDO-BELFAST' },
  { label: 'SINGAPUR-SINGAPORE CHANCI AIPORT' },
  { label: 'SUDÁFRICA-BABELEGI' },
  { label: 'SUDÁFRICA-BISHO' },
  { label: 'SUDÁFRICA-BULTFONTEIN' },
  { label: 'SUDÁFRICA-CRADOCK' },
  { label: 'SUDÁFRICA-DURBAN-VIRGINIA' },
  { label: 'SUDÁFRICA-EMPANGENI' },
  { label: 'SUDÁFRICA-FICKSBURG' },
  { label: 'SUDÁFRICA-GIYANI' },
  { label: 'SUDÁFRICA-HARRISMITH' },
  { label: 'SUDÁFRICA-HAZYVIEW' },
  { label: 'SUDÁFRICA-HLUHLUWE' },
  { label: 'SUDÁFRICA-HOEDSPRUIT' },
  { label: 'SUDÁFRICA-INYATI' },
  { label: 'SUDÁFRICA-JOHANNESBURGO-RAND' },
  { label: 'SUDÁFRICA-JOHANNESBURGO-RANDBURG HELIPORT' },
  { label: 'SUDÁFRICA-KHOKA MOYA' },
  { label: 'SUDÁFRICA-KLERKSDORP' },
  { label: 'SUDÁFRICA-KOINGNAAS' },
  { label: 'SUDÁFRICA-KOMATIPOORT' },
  { label: 'SUDÁFRICA-KURUMAN' },
  { label: 'SUDÁFRICA-LADYSMITH' },
  { label: 'SUDÁFRICA-LANGEBAANWEG' },
  { label: 'SUDÁFRICA-LIME ACRES' },
  { label: 'SUDÁFRICA-LONDOLOZI' },
  { label: 'SUDÁFRICA-LOUIS TRICHARDT' },
  { label: 'SUDÁFRICA-MAFEKING' },
  { label: 'SUDÁFRICA-MALAMALA' },
  { label: 'SUDÁFRICA-MALELANE' },
  { label: 'SUDÁFRICA-MIDRAND' },
  { label: 'SUDÁFRICA-MKUZE' },
  { label: 'SUDÁFRICA-MUBATUWA' },
  { label: 'SUDÁFRICA-NGALA' },
  { label: 'SUDÁFRICA-OVERBERG' },
  { label: 'SUDÁFRICA-PHINDA' },
  { label: 'SUDÁFRICA-PORT ALFRED' },
  { label: 'SUDÁFRICA-PORT ST. JOHNS' },
  { label: 'SUDÁFRICA-POTCHEFSTROOM' },
  { label: 'SUDÁFRICA-PRETORIA' },
  { label: 'SUDÁFRICA-PRETORIA-CENTRAL' },
  { label: 'SUDÁFRICA-PRIESKA' },
  { label: 'SUDÁFRICA-QUEENSTOWN' },
  { label: 'SUDÁFRICA-REIVILO' },
  { label: 'SUDÁFRICA-ROBERTSON' },
  { label: 'SUDÁFRICA-SECUNDA' },
  { label: 'SUDÁFRICA-THOHOYANDOU' },
  { label: 'SUDÁFRICA-TSHIPISE' },
  { label: 'SUDÁFRICA-TZANEEN' },
  { label: 'SUDÁFRICA-ULUSABA' },
  { label: 'SUDÁFRICA-VREDENDAL' },
  { label: 'SUDÁFRICA-VRYBURG' },
  { label: 'SUDÁFRICA-WELVERDIEND' },
  { label: 'SUDÁFRICA-AGGENEYS' },
  { label: 'SUDÁFRICA-ALEXANDER BAY' },
  { label: 'SUDÁFRICA-ALLDAYS' },
  { label: 'SUDÁFRICA-BLOEMFONTEIN' },
  { label: 'SUDÁFRICA-DURBAN' },
  { label: 'SUDÁFRICA-EAST LONDON' },
  { label: 'SUDÁFRICA-GEORGE' },
  { label: 'SUDÁFRICA-KIMBERLEY' },
  { label: 'SUDÁFRICA-MARGATE' },
  { label: 'SUDÁFRICA-MPUMALANGA (KRUGER MPUMALANGA)' },
  { label: 'SUDÁFRICA-NELSPRUIT (MBOMBELA)' },
  { label: 'SUDÁFRICA-NEWCASTLE' },
  { label: 'SUDÁFRICA-PHALABORWA' },
  { label: 'SUDÁFRICA-PIETERMARITZBURG' },
  { label: 'SUDÁFRICA-PIETERSBURG (AHORA POLOKWANE)' },
  { label: 'SUDÁFRICA-PLETTENBERG BAY' },
  { label: 'SUDÁFRICA-PUERTO ELIZABETH (AHORA GQEBERHA)' },
  { label: 'SUDÁFRICA-PRETORIA-LANSERIA INTERNACIONAL' },
  { label: 'SUDÁFRICA-PRETORIA-WONDERBOOM' },
  { label: 'SUDÁFRICA-RICHARDS BAY' },
  { label: 'SUDÁFRICA-SISHEN' },
  { label: 'SUDÁFRICA-SKUKUZA' },
  { label: 'SUDÁFRICA-SPRINGBOK' },
  { label: 'SUDÁFRICA-SUN CITY' },
  { label: 'SUDÁFRICA-ULUNDI' },
  { label: 'SUDÁFRICA-UMTATA (AHORA MTHATHA)' },
  { label: 'SUDÁFRICA-UPINGTON' },
  { label: 'SUDÁFRICA-CIUDAD DEL CABO' },
  { label: 'SUDÁFRICA-JOHANNESBURGO' },
  { label: 'SWEDEN-SCOTTSDALE' },
  { label: 'TAIWAN-TAIPEI' },
  { label: 'TENERIFFA/SPAIN-TENERIFE-SUR REINA SOFIA' },
  { label: 'TENERIFFA/SPAIN-TENERIFE-TENERIFE SOUTH' },
  { label: 'TURQUÍA-AFYONKARAHISAR' },
  { label: 'TURQUÍA-AGRI' },
  { label: 'TURQUÍA-AMASYA' },
  { label: 'TURQUÍA-AYDIN' },
  { label: 'TURQUÍA-BALIKESIR' },
  { label: 'TURQUÍA-BALIKESIR-MERKEZ' },
  { label: 'TURQUÍA-BANDIRMA' },
  { label: 'TURQUÍA-BATMAN' },
  { label: 'TURQUÍA-BURSA' },
  { label: 'TURQUÍA-BURSA-BURSA YENIŞEHIR' },
  { label: 'TURQUÍA-ÇANAKKALE' },
  { label: 'TURQUÍA-CENGIZ TOPEL' },
  { label: 'TURQUÍA-ÇIĞLI' },
  { label: 'TURQUÍA-DIYARBAKIR' },
  { label: 'TURQUÍA-EDREMIT' },
  { label: 'TURQUÍA-ELAZIG' },
  { label: 'TURQUÍA-ESKIŞEHIR' },
  { label: 'TURQUÍA-GAZIPAŞA' },
  { label: 'TURQUÍA-GÖKÇEADA' },
  { label: 'TURQUÍA-HAKKARI' },
  { label: 'TURQUÍA-HATAY' },
  { label: 'TURQUÍA-IĞDIR' },
  { label: 'TURQUÍA-IMSIK' },
  { label: 'TURQUÍA-ISPARTA' },
  { label: 'TURQUÍA-KARS' },
  { label: 'TURQUÍA-KASTAMONU' },
  { label: 'TURQUÍA-NEVŞEHIR' },
  { label: 'TURQUÍA-ORDU' },
  { label: 'TURQUÍA-SAMSUN-SAMSUN SAMAIR' },
  { label: 'TURQUÍA-ŞANLIURFA' },
  { label: 'TURQUÍA-ŞANLIURFA-ŞANLIURFA GAP' },
  { label: 'TURQUÍA-SIIRT' },
  { label: 'TURQUÍA-ŞIRNAK' },
  { label: 'TURQUÍA-TOKAT' },
  { label: 'TURQUÍA-UŞAK' },
  { label: 'TURQUÍA-ZONGULDAK' },
  { label: 'TURQUÍA-ADANA' },
  { label: 'TURQUÍA-ADIYAMAN' },
  { label: 'TURQUÍA-ANKARA' },
  { label: 'TURQUÍA-ANTALYA' },
  { label: 'TURQUÍA-BODRUM' },
  { label: 'TURQUÍA-ÇORLU' },
  { label: 'TURQUÍA-DALAMAN' },
  { label: 'TURQUÍA-DENIZLI' },
  { label: 'TURQUÍA-ERZINCAN' },
  { label: 'TURQUÍA-ERZURUM' },
  { label: 'TURQUÍA-GAZIANTEP' },
  { label: 'TURQUÍA-ESTAMBUL-SABIHA GÖKÇEN INT.' },
  { label: 'TURQUÍA-ESMIRNA' },
  { label: 'TURQUÍA-KAHRAMANMARAŞ' },
  { label: 'TURQUÍA-KAYSERI' },
  { label: 'TURQUÍA-KONYA' },
  { label: 'TURQUÍA-MALATYA' },
  { label: 'TURQUÍA-MARDIN' },
  { label: 'TURQUÍA-MUŞ' },
  { label: 'TURQUÍA-SAMSUN' },
  { label: 'TURQUÍA-SIVAS' },
  { label: 'TURQUÍA-TREBISONDA' },
  { label: 'TURQUÍA-VAN' },
  { label: 'TURQUÍA-ANKARA-ETIMESGUT' },
  { label: 'TURQUÍA-ESTAMBUL' },
  { label: 'ZIMBABWE-SIENA-SIENA-AMPUGNANO' },
];
